import React, { useState, useEffect, useRef } from 'react';
import { gql, useMutation, useQuery } from '@apollo/client';
import BarraNavegacion from './BarraNavegacion';
import Finalizar from './FinalizarCompra.jsx';
import '../App.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import { faUserNurse } from '@fortawesome/free-solid-svg-icons';
import FinalizarCompra from './FinalizarCompra.jsx'
import FruitLoader from './FruitLoader.jsx';
import jsPDF from 'jspdf';


const INCREMENTAR_VENDIDOS = gql`
  mutation incrementarVendidos($id: ID!, $cantidad: Int!) {
    incrementarVendidos(id: $id, cantidad: $cantidad) {
      _id
      cantidad
    }
  }
`;

const GET_PRODUCTOS = gql`
  query getProductos {
    getProductos {
      _id
      nombre
      imagen
      codigo
      precio
      stock
    }
  }
`;

const OBTENER_PESO = gql`
  query {
    pesoBascula
  }
`;

 /*const ACTUALIZAR_STOCK = gql`
  mutation actualizarStock($id: ID!, $nuevoStock: Int) {
    actualizarStock(_id: $id, stock: $nuevoStock) {
      _id
      nombre
      precio
      stock
      codigo
      imagen
    }
  }
`;*/

const NUEVO_PEDIDO = gql`
  mutation crearPedido(
    $estado: String
    $fecha: Date
    $nombreCliente: String
    $direccionCliente: String
    $whatsappCliente: String
    $notaPedido: String
    $productos: String
  ) {
    crearPedido(
      estado: $estado
      fecha: $fecha
      nombreCliente: $nombreCliente
      direccionCliente: $direccionCliente
      whatsappCliente: $whatsappCliente
      notaPedido: $notaPedido
      productos: $productos
    ) {
      _id
      estado
      fecha
      numeroPedido
      nombreCliente
      direccionCliente
      whatsappCliente
      notaPedido
      productos
    }
  }
`;
// ✅ Función para obtener fecha actual GMT-5 con día de la semana (capitalizado)
function getFechaGMT5() {
  const fechaUTC = new Date();
  const offsetColombia = 0; // Colombia UTC-5
  const fechaColombia = new Date(fechaUTC.getTime() + offsetColombia * 60 * 1000);

  const diasSemana = [
    "Domingo",
    "Lunes",
    "Martes",
    "Miércoles",
    "Jueves",
    "Viernes",
    "Sábado"
  ];

  const diaSemana = diasSemana[fechaColombia.getDay()];
  const year = fechaColombia.getFullYear();
  const month = (fechaColombia.getMonth() + 1).toString().padStart(2, '0');
  const day = fechaColombia.getDate().toString().padStart(2, '0');
  const hours = fechaColombia.getHours().toString().padStart(2, '0');
  const minutes = fechaColombia.getMinutes().toString().padStart(2, '0');

  return `${diaSemana} - ${day}/${month}/${year} ${hours}:${minutes}`;
}


function ProductosAgotados(props) {
  const [carrito3, setCarrito3] = useState([]);
  const [filtro, setFiltro] = useState('');
  const [total, setTotal] = useState(0);
  const inputRef = useRef(null);
 const [dineroCliente, setDineroCliente] = useState('');
const [cambio, setCambio] = useState(0);
const [mantenerFocoBusqueda, setMantenerFocoBusqueda] = useState(true);


  // const [actualizarStockProducto] = useMutation(ACTUALIZAR_STOCK);
  const productoSeleccionadoRef = useRef(null);
  const [estado, setEstado] = useState("esperando");
  const [fecha, setFecha] = useState(getFechaGMT5());
  const [nombreCliente, setNombreCliente] = useState("");
  const [direccionCliente, setDireccionCliente] = useState("");
  const [whatsappCliente, setWhatsappCliente] = useState("");
  const [notaPedido, setNotaPedido] = useState("");
  const [productos, setProductos] = useState("");
  const [nuevoPedido] = useMutation(NUEVO_PEDIDO);
  const [carritoLocal3, setCarritoLocal3] = useState([]);
  const [incrementarVendidos] = useMutation(INCREMENTAR_VENDIDOS);
  const [indiceSeleccionado, setIndiceSeleccionado] = useState(0);
const { data: productosData, loading: productosLoading, error: productosError } = useQuery(GET_PRODUCTOS);
  const { data: pesoData, loading: pesoLoading, error: pesoError } = useQuery(OBTENER_PESO, {
    pollInterval: 1000,
  });

 const [modalActivo, setModalActivo] = useState(null);


  useEffect(() => {
    const carritoGuardado = JSON.parse(localStorage.getItem('carrito3')) || [];
    setCarrito3(carritoGuardado);
  }, []);

  useEffect(() => {
    localStorage.setItem('carrito3', JSON.stringify(carrito3));
    recalcularTotal(); // Recalcular el total cuando el carrito cambia
  }, [carrito3]);



  useEffect(() => {
  const interval = setInterval(() => {
    const activeElement = document.activeElement;
    const esInputBusqueda = inputRef.current === activeElement;
    const esOtroInput = activeElement.tagName === 'INPUT' && !esInputBusqueda;

    if (!esOtroInput && inputRef.current) {
      inputRef.current.focus();
    }
  }, 300); // menos frecuente que antes

  return () => clearInterval(interval);
}, []);

useEffect(() => {
  if (mantenerFocoBusqueda && inputRef.current) {
    inputRef.current.focus();
  }
}, [mantenerFocoBusqueda]);




  const buscarYAgregarProducto = (codigo) => {
    if (!productosData || !productosData.getProductos) {
      console.error('Datos de productos no disponibles');
      alert('Datos de productos no cargados. Por favor, intente nuevamente.');
      return;
    }

    const productoFiltrado = productosData.getProductos.find(
      (producto) => producto.codigo === codigo
    );

    if (productoFiltrado) {
      agregarAlCarrito(productoFiltrado);
    } else {
      //alert('Producto no encontrado');
    }
  };

const agregarAlCarrito = async (producto) => {
  let cantidad = 1;

  if (producto.codigo === "1") {
    const peso = parseFloat(pesoData?.pesoBascula || 0);
    if (!peso || isNaN(peso) || peso <= 0) {
     // alert('No se detectó un peso válido en la báscula');
      return;
    }
    cantidad = Math.round(peso * 1000);
  }

  const productoEnCarrito = carrito3.find((item) => item._id === producto._id && item.origen === modalActivo);

  if (productoEnCarrito) {
    const nuevaCantidad = productoEnCarrito.cantidad + cantidad;
    if (nuevaCantidad <= producto.stock) {
      const carritoActualizado = carrito3.map((item) =>
        item._id === producto._id && item.origen === modalActivo
          ? { ...item, cantidad: nuevaCantidad }
          : item
      );
      setCarrito3(carritoActualizado);
    }
  } else {
    if (producto.stock >= cantidad) {
      setCarrito3([
        ...carrito3,
        { 
          ...producto, 
          cantidad, 
          fechaAgregado: getFechaGMT5(),
          origen: modalActivo   // ✅ guardar de qué modal viene
        }
      ]);
    }
  }
  setFiltro("");
};

const cantidadPorModal = (modal) => {
  return carrito3
    .filter(producto => producto.origen === modal)
    .reduce((acc, producto) => acc + producto.cantidad, 0);
};



  const modificarCantidad = async (productId, cantidad) => {
    const productoEnCarrito = carrito3.find(
      (producto) => producto._id === productId
    );
    const productoEnData = productosData.getProductos.find(
      (producto) => producto._id === productId
    );

    if (!productoEnCarrito || !productoEnData) return;

    const nuevaCantidad = productoEnCarrito.cantidad + cantidad;

    if (nuevaCantidad <= 0) {
      return eliminarProductoDelCarrito(productId);
    }

    if (productoEnData.stock === 0) {
     // alert('No hay suficiente stock disponible para este producto.');
      return;
    }

    const carritoActualizado = carrito3.map((item) =>
      item._id === productId ? { ...item, cantidad: nuevaCantidad } : item
    );
    setCarrito3(carritoActualizado);

    // const nuevoStock = productoEnData.stock - cantidad;
    // await actualizarStockProducto({
    //   variables: { id: productId, nuevoStock },
    // });
  };

  useEffect(() => {
    setCarritoLocal3(carrito3);  // Actualiza carritoLocal cuando carrito cambie
  }, [carrito3]);
  
  const eliminarProductoDelCarrito = async (productId) => {
    const productoEnCarrito = carrito3.find(
      (producto) => producto._id === productId
    );

    if (productoEnCarrito) {
      // const nuevoStock =
      //   data.getProductos.find((producto) => producto._id === productId).stock +
      //   productoEnCarrito.cantidad;
      // await actualizarStockProducto({
      //   variables: { id: productId, nuevoStock },
      // });
    }

    const carritoActualizado = carrito3.filter(
      (producto) => producto._id !== productId
    );
    setCarrito3(carritoActualizado);
  };

  const eliminarTodoElCarrito = async () => {
    for (let producto of carrito3) {
      // const nuevoStock =
      //   data.getProductos.find((item) => item._id === producto._id).stock +
      //   producto.cantidad;
      // await actualizarStockProducto({
      //   variables: { id: producto._id, nuevoStock },
      // });
    }
    setCarrito3([]);
    localStorage.setItem('carrito3', JSON.stringify([]));
  };

  {/*const handleFiltroChange = (e) => {
    setFiltro(e.target.value);
  };*/}

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      buscarYAgregarProducto(filtro);
      setFiltro('');
    }
  };

  const recalcularTotal = () => {
    const nuevoTotal = carrito3.reduce((acc, producto) => {
      const subtotal = producto.codigo === "1"
        ? (producto.precio * producto.cantidad) + 200
        : producto.precio * producto.cantidad;
      return acc + subtotal;
    }, 0);
    setTotal(nuevoTotal);
  };
  
  const [productosFiltrados, setProductosFiltrados] = useState([]);

  const handleFiltroChange = (e) => {
    const filtro = e.target.value.toLowerCase();
    setFiltro(filtro);
    const productosFiltrados = productosData.getProductos.filter((producto) =>
      producto.nombre.toLowerCase().includes(filtro)
    );
    setProductosFiltrados(productosFiltrados);
    setIndiceSeleccionado(0);
  };
  
  // const [actualizarStock] = useMutation(ACTUALIZAR_STOCK);


  const handleCompraClick = async () => {
  for (const producto of carrito3) {
  //  await incrementarVendidos({
 // variables: {
  //  id: producto._id,
   // cantidad: parseInt(producto.cantidad, 10), // ✅ conversión segura
 // },
//});
  }

  localStorage.removeItem('carrito3');
  setCarrito3([]);
};


   // Generar mensaje de WhatsApp
   const generarMensajeWhatsapp = () => {
    let mensaje = `Hola ${nombreCliente}, gracias por tu compra.\n\nDetalles de compra:\n`;

  carritoLocal3.forEach((producto) => {
  const precioCalculado = producto.codigo === "1"
    ? (producto.precio * 1000 + 200)
    : (producto.precio);

  mensaje += `${producto.nombre} - Cantidad: ${producto.cantidad} - Precio: ${precioCalculado}\n`;
});

const totalPedido = carritoLocal3.reduce((total, prod) => {
  const precioCalculado = prod.codigo === "1"
    ? prod.precio * 1000 + 200
    : prod.precio;
  return total + (precioCalculado * prod.cantidad);
}, 0);

mensaje += `\nTotal del pedido: ${totalPedido}\n`;
mensaje += `\nDirección de entrega: ${direccionCliente}\n`;
mensaje += `Nota: ${notaPedido}`;

return encodeURIComponent(mensaje);
  };

  // Generar PDF con datos del cliente y productos
  const generarPDF = () => {
    const doc = new jsPDF();
    
    // Añadir datos del cliente
  
    doc.text(`Cliente: ${nombreCliente}`, 10, 20);
    doc.text(`Dirección: ${direccionCliente}`, 10, 30);
    doc.text(`WhatsApp: ${whatsappCliente}`, 10, 40);
    
    // Añadir detalles del pedido
    doc.text("Detalles de la compra", 10, 50);
      doc.text("Detalles de la compra", 10, 50);
    carritoLocal3.forEach((producto, index) => {
      doc.text(`${producto.nombre} - Cantidad: ${producto.cantidad} - Precio:0 ${producto.codigo === "1"
                    ? (producto.precio )*1000 + 200
                    : producto.precio}`, 10, 60 + (index * 10));
    });

  const total = carritoLocal3.reduce((total, prod) => {
  const precioCalculado = prod.codigo === "1"
    ? prod.precio * 1000 + 200
    : prod.precio;
  return total + (precioCalculado * prod.cantidad);
}, 0);

doc.text(`Total del pedido: ${total.toFixed(0)}`, 10, 70 + (carritoLocal3.length * 10));

doc.save('pedido.pdf'); 
  };

  const pedidoSubmit = async (e) => {
    e.preventDefault();
    const carritoString = JSON.stringify(carritoLocal3);

    // Crear pedido en la base de datos
    await nuevoPedido({
      variables: {
        estado,
        fecha,
        nombreCliente,
        direccionCliente,
        whatsappCliente,
        notaPedido,
        productos: carritoString,
      },
    });

     // Actualizar stock, generar PDF y abrir WhatsApp
     handleCompraClick();
     {/**generarPDF();
 
     // Redirigir a WhatsApp en una nueva ventana o reutilizar una existente
     const numeroWhatsApp = `57${whatsappCliente}`;
     const mensaje = generarMensajeWhatsapp();
     const enlaceWhatsApp = `https://web.whatsapp.com/send?phone=${numeroWhatsApp}&text=${mensaje}`;
     window.open(enlaceWhatsApp, 'whatsappWindow');*/}
 
     // Limpiar los campos del formulario
     setNombreCliente("");
     setFecha(getFechaGMT5());
     setDireccionCliente("");
     setWhatsappCliente("");
     setNotaPedido("");
     setDineroCliente("");
   };

   useEffect(() => {
  const entregado = parseFloat(dineroCliente);
  if (!isNaN(entregado)) {
    setCambio(entregado - total);
  } else {
    setCambio(0);
  }
}, [dineroCliente, total]);



useEffect(() => {
  const handleCantidadConTeclado = (event) => {
    if (carrito3.length === 0) return;

    if (event.key === '+' || event.key === '-') {
      event.preventDefault(); // 🔴 Evita que escriba en el input

      const ultimoProducto = carrito3[carrito3.length - 1];

      if (event.key === '+') {
        modificarCantidad(ultimoProducto._id, 1);
      } else if (event.key === '-') {
        modificarCantidad(ultimoProducto._id, -1);
      }
    }



    
  };

  

  window.addEventListener('keydown', handleCantidadConTeclado);

  return () => {
    window.removeEventListener('keydown', handleCantidadConTeclado);
  };
}, [carrito3]);





   if (productosLoading || pesoLoading) return <p><FruitLoader></FruitLoader></p>;
  if (productosError) return <p>Error al cargar productos</p>;
  if (pesoError) return <p>Error al leer la báscula</p>;
  
  return (
    <div className="">
      <center> <h1>Gestion de productos agotados</h1></center>
     
<button className="btn btn-salida" onClick={() => setModalActivo("alpina")}>
  Alpina
  {cantidadPorModal("alpina") > 0 && (
    <span className="badge bg-danger ms-2">
      {cantidadPorModal("alpina")}
    </span>
  )}
</button>


<button className="btn btn-salida" onClick={() => setModalActivo("altipal")}>
  Altipal
  {cantidadPorModal("altipal") > 0 && (
    <span className="badge bg-danger ms-2">
      {cantidadPorModal("altipal")}
    </span>
  )}
</button>
<button className="btn btn-salida" onClick={() => setModalActivo("auralac")}>
  Auralac
  {cantidadPorModal("auralac") > 0 && (
    <span className="badge bg-danger ms-2">
      {cantidadPorModal("auralac")}
    </span>
  )}
</button>

<button className="btn btn-salida" onClick={() => setModalActivo("bimbo")}>
  Bimbo
  {cantidadPorModal("bimbo") > 0 && (
    <span className="badge bg-danger ms-2">
      {cantidadPorModal("bimbo")}
    </span>
  )}
</button>
<button className="btn btn-salida" onClick={() => setModalActivo("bucanero")}>
  Bucanero
  {cantidadPorModal("bucanero") > 0 && (
    <span className="badge bg-danger ms-2">
      {cantidadPorModal("bucanero")}
    </span>
  )}
</button>

<button className="btn btn-salida" onClick={() => setModalActivo("calidoso")}>
  Calidoso
  {cantidadPorModal("calidoso") > 0 && (
    <span className="badge bg-danger ms-2">
      {cantidadPorModal("calidoso")}
    </span>
  )}
</button>
<button className="btn btn-salida" onClick={() => setModalActivo("caribe")}>
  Caribe
  {cantidadPorModal("caribe") > 0 && (
    <span className="badge bg-danger ms-2">
      {cantidadPorModal("caribe")}
    </span>
  )}
</button>

<button className="btn btn-salida" onClick={() => setModalActivo("carriel")}>
  Carriel
  {cantidadPorModal("carriel") > 0 && (
    <span className="badge bg-danger ms-2">
      {cantidadPorModal("carriel")}
    </span>
  )}
</button>
<button className="btn btn-salida" onClick={() => setModalActivo("casangel")}>
  Casangel
  {cantidadPorModal("casangel") > 0 && (
    <span className="badge bg-danger ms-2">
      {cantidadPorModal("casangel")}
    </span>
  )}
</button>

<button className="btn btn-salida" onClick={() => setModalActivo("caseritas")}>
  Caseritas
  {cantidadPorModal("caseritas") > 0 && (
    <span className="badge bg-danger ms-2">
      {cantidadPorModal("caseritas")}
    </span>
  )}
</button>
<button className="btn btn-salida" onClick={() => setModalActivo("choriunion")}>
  Choriunion
  {cantidadPorModal("choriunion") > 0 && (
    <span className="badge bg-danger ms-2">
      {cantidadPorModal("choriunion")}
    </span>
  )}
</button>

<button className="btn btn-salida" onClick={() => setModalActivo("cocacola")}>
  Cocacola
  {cantidadPorModal("cocacola") > 0 && (
    <span className="badge bg-danger ms-2">
      {cantidadPorModal("cocacola")}
    </span>
  )}
</button>
<button className="btn btn-salida" onClick={() => setModalActivo("colanta")}>
  Colanta
  {cantidadPorModal("colanta") > 0 && (
    <span className="badge bg-danger ms-2">
      {cantidadPorModal("colanta")}
    </span>
  )}
</button>

<button className="btn btn-salida" onClick={() => setModalActivo("colombina")}>
  Colombina
  {cantidadPorModal("colombina") > 0 && (
    <span className="badge bg-danger ms-2">
      {cantidadPorModal("colombina")}
    </span>
  )}
</button>
<button className="btn btn-salida" onClick={() => setModalActivo("dan")}>
  Dan
  {cantidadPorModal("dan") > 0 && (
    <span className="badge bg-danger ms-2">
      {cantidadPorModal("dan")}
    </span>
  )}
</button>

<button className="btn btn-salida" onClick={() => setModalActivo("dg")}>
  DG
  {cantidadPorModal("dg") > 0 && (
    <span className="badge bg-danger ms-2">
      {cantidadPorModal("dg")}
    </span>
  )}
</button>
<button className="btn btn-salida" onClick={() => setModalActivo("distiendas")}>
  Distiendas
  {cantidadPorModal("distiendas") > 0 && (
    <span className="badge bg-danger ms-2">
      {cantidadPorModal("distiendas")}
    </span>
  )}
</button>

<button className="btn btn-salida" onClick={() => setModalActivo("distrimarcas")}>
  Distrimarcas
  {cantidadPorModal("distrimarcas") > 0 && (
    <span className="badge bg-danger ms-2">
      {cantidadPorModal("distrimarcas")}
    </span>
  )}
</button>
<button className="btn btn-salida" onClick={() => setModalActivo("dorado")}>
  Dorado
  {cantidadPorModal("dorado") > 0 && (
    <span className="badge bg-danger ms-2">
      {cantidadPorModal("dorado")}
    </span>
  )}
</button>

<button className="btn btn-salida" onClick={() => setModalActivo("epa")}>
  Epa
  {cantidadPorModal("epa") > 0 && (
    <span className="badge bg-danger ms-2">
      {cantidadPorModal("epa")}
    </span>
  )}
</button>
<button className="btn btn-salida" onClick={() => setModalActivo("familia")}>
  Familia
  {cantidadPorModal("familia") > 0 && (
    <span className="badge bg-danger ms-2">
      {cantidadPorModal("familia")}
    </span>
  )}
</button>
<button className="btn btn-salida" onClick={() => setModalActivo("flor-trigo")}>
  Flor del trigo
  {cantidadPorModal("flor-trigo") > 0 && (
    <span className="badge bg-danger ms-2">
      {cantidadPorModal("flor-trigo")}
    </span>
  )}
</button>
<button className="btn btn-salida" onClick={() => setModalActivo("frios-montaña")}>
  Frios de la montaña
  {cantidadPorModal("frios-montaña") > 0 && (
    <span className="badge bg-danger ms-2">
      {cantidadPorModal("frios-montaña")}
    </span>
  )}
</button>
<button className="btn btn-salida" onClick={() => setModalActivo("fricar")}>
  Fricar
  {cantidadPorModal("fricar") > 0 && (
    <span className="badge bg-danger ms-2">
      {cantidadPorModal("fricar")}
    </span>
  )}
</button>

<button className="btn btn-salida" onClick={() => setModalActivo("frito-lay")}>
  Frito lay
  {cantidadPorModal("frito-lay") > 0 && (
    <span className="badge bg-danger ms-2">
      {cantidadPorModal("frito-lay")}
    </span>
  )}
</button>
<button className="btn btn-salida" onClick={() => setModalActivo("gerardo")}>
  Gerardo
  {cantidadPorModal("gerardo") > 0 && (
    <span className="badge bg-danger ms-2">
      {cantidadPorModal("gerardo")}
    </span>
  )}
</button>

<button className="btn btn-salida" onClick={() => setModalActivo("granja")}>
  Granja
  {cantidadPorModal("granja") > 0 && (
    <span className="badge bg-danger ms-2">
      {cantidadPorModal("granja")}
    </span>
  )}
</button>
<button className="btn btn-salida" onClick={() => setModalActivo("gyg")}>
  G y G
  {cantidadPorModal("gyg") > 0 && (
    <span className="badge bg-danger ms-2">
      {cantidadPorModal("gyg")}
    </span>
  )}
</button>

<button className="btn btn-salida" onClick={() => setModalActivo("jaf")}>
  Jaf
  {cantidadPorModal("jaf") > 0 && (
    <span className="badge bg-danger ms-2">
      {cantidadPorModal("jaf")}
    </span>
  )}
</button>
<button className="btn btn-salida" onClick={() => setModalActivo("legumbres")}>
  Legumbres
  {cantidadPorModal("legumbres") > 0 && (
    <span className="badge bg-danger ms-2">
      {cantidadPorModal("legumbres")}
    </span>
  )}
</button>
<button className="btn btn-salida" onClick={() => setModalActivo("mayorista")}>
  Mayorista
  {cantidadPorModal("mayorista") > 0 && (
    <span className="badge bg-danger ms-2">
      {cantidadPorModal("mayorista")}
    </span>
  )}
</button>
<button className="btn btn-salida" onClick={() => setModalActivo("mercaventas")}>
  Mercaventas
  {cantidadPorModal("mercaventas") > 0 && (
    <span className="badge bg-danger ms-2">
      {cantidadPorModal("mercaventas")}
    </span>
  )}
</button>
<button className="btn btn-salida" onClick={() => setModalActivo("mygcondimentos")}>
  M&g condimentos
  {cantidadPorModal("mygcondimentos") > 0 && (
    <span className="badge bg-danger ms-2">
      {cantidadPorModal("mygcondimentos")}
    </span>
  )}
</button>

<button className="btn btn-salida" onClick={() => setModalActivo("nestle")}>
  Nestle
  {cantidadPorModal("nestle") > 0 && (
    <span className="badge bg-danger ms-2">
      {cantidadPorModal("nestle")}
    </span>
  )}
</button>
<button className="btn btn-salida" onClick={() => setModalActivo("postobon")}>
  Postobon
  {cantidadPorModal("postobon") > 0 && (
    <span className="badge bg-danger ms-2">
      {cantidadPorModal("postobon")}
    </span>
  )}
</button>

<button className="btn btn-salida" onClick={() => setModalActivo("proriente")}>
  Pro oriente
  {cantidadPorModal("proriente") > 0 && (
    <span className="badge bg-danger ms-2">
      {cantidadPorModal("proriente")}
    </span>
  )}
</button>
<button className="btn btn-salida" onClick={() => setModalActivo("quala")}>
  Quala
  {cantidadPorModal("quala") > 0 && (
    <span className="badge bg-danger ms-2">
      {cantidadPorModal("quala")}
    </span>
  )}
</button>
<button className="btn btn-salida" onClick={() => setModalActivo("ramo")}>
  Ramo
  {cantidadPorModal("ramo") > 0 && (
    <span className="badge bg-danger ms-2">
      {cantidadPorModal("ramo")}
    </span>
  )}
</button>

<button className="btn btn-salida" onClick={() => setModalActivo("red-de-marcas")}>
  Red de marcas
  {cantidadPorModal("red-de-marcas") > 0 && (
    <span className="badge bg-danger ms-2">
      {cantidadPorModal("red-de-marcas")}
    </span>
  )}
</button>
<button className="btn btn-salida" onClick={() => setModalActivo("sol-oriente")}>
  Sol de oriente
  {cantidadPorModal("sol-oriente") > 0 && (
    <span className="badge bg-danger ms-2">
      {cantidadPorModal("sol-oriente")}
    </span>
  )}
</button>

<button className="btn btn-salida" onClick={() => setModalActivo("somos-sabor")}>
  Somos sabor
  {cantidadPorModal("somos-sabor") > 0 && (
    <span className="badge bg-danger ms-2">
      {cantidadPorModal("somos-sabor")}
    </span>
  )}
</button>
<button className="btn btn-salida" onClick={() => setModalActivo("sonsoneña")}>
  Sonsoneña
  {cantidadPorModal("sonsoneña") > 0 && (
    <span className="badge bg-danger ms-2">
      {cantidadPorModal("sonsoneña")}
    </span>
  )}
</button>
<button className="btn btn-salida" onClick={() => setModalActivo("yupi")}>
Yupi
  {cantidadPorModal("yupi") > 0 && (
    <span className="badge bg-danger ms-2">
      {cantidadPorModal("yupi")}
    </span>
  )}
</button>
<button className="btn btn-salida" onClick={() => setModalActivo("zenu")}>
Zenu
  {cantidadPorModal("zenu") > 0 && (
    <span className="badge bg-danger ms-2">
      {cantidadPorModal("zenu")}
    </span>
  )}
</button>
<button className="btn btn-salida" onClick={() => setModalActivo("otros")}>
  Otros
  {cantidadPorModal("otros") > 0 && (
    <span className="badge bg-danger ms-2">
      {cantidadPorModal("otros")}
    </span>
  )}
</button>
{modalActivo === "alpina" && (
    <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ background: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Alpina</h5>
              <button className="btn-close" onClick={() => setModalActivo(null)}></button>
       
        </div>
        <div className="modal-body">
         

 <div className="container">
      <div className="row ">
      
       <input
  ref={inputRef}
  type="text"
  placeholder="Escanee el código de barras o escribe el nombre del producto"
  value={filtro}
  onChange={handleFiltroChange}
  onKeyPress={handleKeyPress}
  onFocus={() => setMantenerFocoBusqueda(true)}
  style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
/>
<h1>Productos agotados</h1>
        
        {filtro === '' ? (
  <p></p>
) : productosFiltrados.length === 0 ? (
  <p>No se encontraron productos que coincidan con la búsqueda</p>
) : (
  <div className="row">
    {productosFiltrados.map((producto, index) => (
      <div key={index} className="col-12 col-lg-4">
        <div
          className="card card-legumbre"
          style={{
            backgroundImage: `url(${producto.imagen})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            height: '200px',
            position: 'relative',
            marginBottom: '20px',
            borderRadius: '10px',
            overflow: 'hidden',
            border: '1px solid #ccc',
          }}
        >
          <div
            className="card-body"
            style={{
              backgroundColor: 'rgba(134, 249, 176, 0.54)',
              height: '100%',
              padding: '10px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
            }}
          >
            <h4 className="card-title" style={{ fontWeight: 'bold' }}>
              {producto.nombre}
            </h4>

            <button
              className="btn btn-primary btn-legumbre mt-2"
              onClick={() => agregarAlCarrito(producto)}
            >
              Agregar
            </button>
          </div>
        </div>
      </div>
    ))}
  </div>
)}

        
        <div className="col-md-9">
          
            {carrito3.filter(producto => producto.origen === "alpina").slice().reverse().map((producto, index) => (
              <li
                key={index}
                className="producto-item"
                onMouseEnter={() => (productoSeleccionadoRef.current = producto._id)}
                onMouseLeave={() => (productoSeleccionadoRef.current = null)}
              >

                
                <div className="">
                 <h3> <img src={producto.imagen} width="100px" alt="" />  {producto.nombre}</h3>
                </div>
              
               
                <div className="producto-subtotal">
                
                  <button className="btn btn-danger" onClick={() => eliminarProductoDelCarrito(producto._id)}>
                    Eliminar
                  </button>
                  <h4>Agotado desde  {producto.fechaAgregado}</h4>
                </div>
              </li>
            ))}
          
        </div>

     
      </div>
    </div>
         
        </div>
        <div className="modal-footer">
            
        </div>
      </div>
    </div>
  </div>
    






)}
 {modalActivo === "altipal" && (
    <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ background: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Altipal</h5>
              <button className="btn-close" onClick={() => setModalActivo(null)}></button>
       
        </div>
        <div className="modal-body">
         

 <div className="container">
      <div className="row ">
      
       <input
  ref={inputRef}
  type="text"
  placeholder="Escanee el código de barras o escribe el nombre del producto"
  value={filtro}
  onChange={handleFiltroChange}
  onKeyPress={handleKeyPress}
  onFocus={() => setMantenerFocoBusqueda(true)}
  style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
/>
<h1>Productos agotados</h1>
        
        {filtro === '' ? (
  <p></p>
) : productosFiltrados.length === 0 ? (
  <p>No se encontraron productos que coincidan con la búsqueda</p>
) : (
  <div className="row">
    {productosFiltrados.map((producto, index) => (
      <div key={index} className="col-12 col-lg-4">
        <div
          className="card card-legumbre"
          style={{
            backgroundImage: `url(${producto.imagen})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            height: '200px',
            position: 'relative',
            marginBottom: '20px',
            borderRadius: '10px',
            overflow: 'hidden',
            border: '1px solid #ccc',
          }}
        >
          <div
            className="card-body"
            style={{
              backgroundColor: 'rgba(134, 249, 176, 0.54)',
              height: '100%',
              padding: '10px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
            }}
          >
            <h4 className="card-title" style={{ fontWeight: 'bold' }}>
              {producto.nombre}
            </h4>

            <button
              className="btn btn-primary btn-legumbre mt-2"
              onClick={() => agregarAlCarrito(producto)}
            >
              Agregar
            </button>
          </div>
        </div>
      </div>
    ))}
  </div>
)}

        
        <div className="col-md-9">
          
            {carrito3.filter(producto => producto.origen === "altipal").slice().reverse().map((producto, index) => (
              <li
                key={index}
                className="producto-item"
                onMouseEnter={() => (productoSeleccionadoRef.current = producto._id)}
                onMouseLeave={() => (productoSeleccionadoRef.current = null)}
              >

                
                <div className="">
                 <h3> <img src={producto.imagen} width="100px" alt="" />  {producto.nombre}</h3>
                </div>
              
               
                <div className="producto-subtotal">
                
                  <button className="btn btn-danger" onClick={() => eliminarProductoDelCarrito(producto._id)}>
                    Eliminar
                  </button>
                  <h4>Agotado desde  {producto.fechaAgregado}</h4>
                </div>
              </li>
            ))}
          
        </div>

     
      </div>
    </div>
         
        </div>
        <div className="modal-footer">
            
        </div>
      </div>
    </div>
  </div>
    






)}
{modalActivo === "auralac" && (
    <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ background: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Auralac</h5>
              <button className="btn-close" onClick={() => setModalActivo(null)}></button>
       
        </div>
        <div className="modal-body">
         

 <div className="container">
      <div className="row ">
      
       <input
  ref={inputRef}
  type="text"
  placeholder="Escanee el código de barras o escribe el nombre del producto"
  value={filtro}
  onChange={handleFiltroChange}
  onKeyPress={handleKeyPress}
  onFocus={() => setMantenerFocoBusqueda(true)}
  style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
/>
<h1>Productos agotados</h1>
        
        {filtro === '' ? (
    <p></p>
  ) :productosFiltrados.length === 0 ? (
          <p>No se encontraron productos que coincidan con la busqueda</p>
        ) : (
          <div className="row">
           {productosFiltrados.map((producto, index) => {
  const esSeleccionado = indiceSeleccionado === index;

  return (
    <div key={index} className="col-12 col-lg-4">
      <div
        className={`card card-legumbre ${esSeleccionado ? 'seleccionado' : ''}`}
        style={{
          backgroundImage: `url(${producto.imagen})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '200px',
          color: esSeleccionado ? 'white' : 'black',
          position: 'relative',
          marginBottom: '20px',
          borderRadius: '10px',
          overflow: 'hidden',
          filter: esSeleccionado ? 'none' : 'brightness(1)',
          border: esSeleccionado ? '2px solid #007bff' : '1px solid #ccc',
          boxShadow: esSeleccionado ? '0 0 10px #007bff' : 'none',
        }}
      >
        <div
          className="card-body"
          style={{
            backgroundColor: esSeleccionado ? 'rgba(40, 66, 50, 0.69)' : 'rgba(134, 249, 176, 0.54)',
            height: '100%',
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <h4 className="card-title" style={{ fontWeight: 'bold' }}>{producto.nombre}</h4>
           
          

           
          </div>

          <button
            className="btn btn-primary btn-legumbre mt-2"
            onClick={() => agregarAlCarrito(producto)}
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
  );
})}

          </div>
        )}
        
        <div className="col-md-9">
          
            {carrito3.filter(producto => producto.origen === "auralac").slice().reverse().map((producto, index) => (
              <li
                key={index}
                className="producto-item"
                onMouseEnter={() => (productoSeleccionadoRef.current = producto._id)}
                onMouseLeave={() => (productoSeleccionadoRef.current = null)}
              >

                
                <div className="">
                 <h3> <img src={producto.imagen} width="100px" alt="" />  {producto.nombre}</h3>
                </div>
              
               
                <div className="producto-subtotal">
                
                  <button className="btn btn-danger" onClick={() => eliminarProductoDelCarrito(producto._id)}>
                    Eliminar
                  </button>
                  <h4>Agotado desde  {producto.fechaAgregado}</h4>
                </div>
              </li>
            ))}
          
        </div>

     
      </div>
    </div>
         
        </div>
        <div className="modal-footer">
            
        </div>
      </div>
    </div>
  </div>
    






)}
  {modalActivo === "bimbo" && (
    <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ background: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Bimbo</h5>
              <button className="btn-close" onClick={() => setModalActivo(null)}></button>
       
        </div>
        <div className="modal-body">
         

 <div className="container">
      <div className="row ">
      
       <input
  ref={inputRef}
  type="text"
  placeholder="Escanee el código de barras o escribe el nombre del producto"
  value={filtro}
  onChange={handleFiltroChange}
  onKeyPress={handleKeyPress}
  onFocus={() => setMantenerFocoBusqueda(true)}
  style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
/>
<h1>Productos agotados</h1>
        
        {filtro === '' ? (
    <p></p>
  ) :productosFiltrados.length === 0 ? (
          <p>No se encontraron productos que coincidan con la busqueda</p>
        ) : (
          <div className="row">
           {productosFiltrados.map((producto, index) => {
  const esSeleccionado = indiceSeleccionado === index;

  return (
    <div key={index} className="col-12 col-lg-4">
      <div
        className={`card card-legumbre ${esSeleccionado ? 'seleccionado' : ''}`}
        style={{
          backgroundImage: `url(${producto.imagen})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '200px',
          color: esSeleccionado ? 'white' : 'black',
          position: 'relative',
          marginBottom: '20px',
          borderRadius: '10px',
          overflow: 'hidden',
          filter: esSeleccionado ? 'none' : 'brightness(1)',
          border: esSeleccionado ? '2px solid #007bff' : '1px solid #ccc',
          boxShadow: esSeleccionado ? '0 0 10px #007bff' : 'none',
        }}
      >
        <div
          className="card-body"
          style={{
            backgroundColor: esSeleccionado ? 'rgba(40, 66, 50, 0.69)' : 'rgba(134, 249, 176, 0.54)',
            height: '100%',
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <h4 className="card-title" style={{ fontWeight: 'bold' }}>{producto.nombre}</h4>
           
          

           
          </div>

          <button
            className="btn btn-primary btn-legumbre mt-2"
            onClick={() => agregarAlCarrito(producto)}
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
  );
})}

          </div>
        )}
        
        <div className="col-md-9">
          
            {carrito3.filter(producto => producto.origen === "bimbo").slice().reverse().map((producto, index) => (
              <li
                key={index}
                className="producto-item"
                onMouseEnter={() => (productoSeleccionadoRef.current = producto._id)}
                onMouseLeave={() => (productoSeleccionadoRef.current = null)}
              >

                
                <div className="">
                 <h3> <img src={producto.imagen} width="100px" alt="" />  {producto.nombre}</h3>
                </div>
              
               
                <div className="producto-subtotal">
                
                  <button className="btn btn-danger" onClick={() => eliminarProductoDelCarrito(producto._id)}>
                    Eliminar
                  </button>
                  <h4>Agotado desde  {producto.fechaAgregado}</h4>
                </div>
              </li>
            ))}
          
        </div>

     
      </div>
    </div>
         
        </div>
        <div className="modal-footer">
            
        </div>
      </div>
    </div>
  </div>
    )}

{modalActivo === "bucanero" && (
    <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ background: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Bucanero</h5>
              <button className="btn-close" onClick={() => setModalActivo(null)}></button>
       
        </div>
        <div className="modal-body">
         

 <div className="container">
      <div className="row ">
      
       <input
  ref={inputRef}
  type="text"
  placeholder="Escanee el código de barras o escribe el nombre del producto"
  value={filtro}
  onChange={handleFiltroChange}
  onKeyPress={handleKeyPress}
  onFocus={() => setMantenerFocoBusqueda(true)}
  style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
/>
<h1>Productos agotados</h1>
        
        {filtro === '' ? (
    <p></p>
  ) :productosFiltrados.length === 0 ? (
          <p>No se encontraron productos que coincidan con la busqueda</p>
        ) : (
          <div className="row">
           {productosFiltrados.map((producto, index) => {
  const esSeleccionado = indiceSeleccionado === index;

  return (
    <div key={index} className="col-12 col-lg-4">
      <div
        className={`card card-legumbre ${esSeleccionado ? 'seleccionado' : ''}`}
        style={{
          backgroundImage: `url(${producto.imagen})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '200px',
          color: esSeleccionado ? 'white' : 'black',
          position: 'relative',
          marginBottom: '20px',
          borderRadius: '10px',
          overflow: 'hidden',
          filter: esSeleccionado ? 'none' : 'brightness(1)',
          border: esSeleccionado ? '2px solid #007bff' : '1px solid #ccc',
          boxShadow: esSeleccionado ? '0 0 10px #007bff' : 'none',
        }}
      >
        <div
          className="card-body"
          style={{
            backgroundColor: esSeleccionado ? 'rgba(40, 66, 50, 0.69)' : 'rgba(134, 249, 176, 0.54)',
            height: '100%',
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <h4 className="card-title" style={{ fontWeight: 'bold' }}>{producto.nombre}</h4>
           
          

           
          </div>

          <button
            className="btn btn-primary btn-legumbre mt-2"
            onClick={() => agregarAlCarrito(producto)}
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
  );
})}

          </div>
        )}
        
        <div className="col-md-9">
          
            {carrito3.filter(producto => producto.origen === "bucanero").slice().reverse().map((producto, index) => (
              <li
                key={index}
                className="producto-item"
                onMouseEnter={() => (productoSeleccionadoRef.current = producto._id)}
                onMouseLeave={() => (productoSeleccionadoRef.current = null)}
              >

                
                <div className="">
                 <h3> <img src={producto.imagen} width="100px" alt="" />  {producto.nombre}</h3>
                </div>
              
               
                <div className="producto-subtotal">
                
                  <button className="btn btn-danger" onClick={() => eliminarProductoDelCarrito(producto._id)}>
                    Eliminar
                  </button>
                  <h4>Agotado desde  {producto.fechaAgregado}</h4>
                </div>
              </li>
            ))}
          
        </div>

     
      </div>
    </div>
         
        </div>
        <div className="modal-footer">
            
        </div>
      </div>
    </div>
  </div>
    






)}
  {modalActivo === "calidoso" && (
    <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ background: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Calidoso</h5>
              <button className="btn-close" onClick={() => setModalActivo(null)}></button>
       
        </div>
        <div className="modal-body">
         

 <div className="container">
      <div className="row ">
      
       <input
  ref={inputRef}
  type="text"
  placeholder="Escanee el código de barras o escribe el nombre del producto"
  value={filtro}
  onChange={handleFiltroChange}
  onKeyPress={handleKeyPress}
  onFocus={() => setMantenerFocoBusqueda(true)}
  style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
/>
<h1>Productos agotados</h1>
        
        {filtro === '' ? (
    <p></p>
  ) :productosFiltrados.length === 0 ? (
          <p>No se encontraron productos que coincidan con la busqueda</p>
        ) : (
          <div className="row">
           {productosFiltrados.map((producto, index) => {
  const esSeleccionado = indiceSeleccionado === index;

  return (
    <div key={index} className="col-12 col-lg-4">
      <div
        className={`card card-legumbre ${esSeleccionado ? 'seleccionado' : ''}`}
        style={{
          backgroundImage: `url(${producto.imagen})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '200px',
          color: esSeleccionado ? 'white' : 'black',
          position: 'relative',
          marginBottom: '20px',
          borderRadius: '10px',
          overflow: 'hidden',
          filter: esSeleccionado ? 'none' : 'brightness(1)',
          border: esSeleccionado ? '2px solid #007bff' : '1px solid #ccc',
          boxShadow: esSeleccionado ? '0 0 10px #007bff' : 'none',
        }}
      >
        <div
          className="card-body"
          style={{
            backgroundColor: esSeleccionado ? 'rgba(40, 66, 50, 0.69)' : 'rgba(134, 249, 176, 0.54)',
            height: '100%',
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <h4 className="card-title" style={{ fontWeight: 'bold' }}>{producto.nombre}</h4>
           
          

           
          </div>

          <button
            className="btn btn-primary btn-legumbre mt-2"
            onClick={() => agregarAlCarrito(producto)}
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
  );
})}

          </div>
        )}
        
        <div className="col-md-9">
          
            {carrito3.filter(producto => producto.origen === "calidoso").slice().reverse().map((producto, index) => (
              <li
                key={index}
                className="producto-item"
                onMouseEnter={() => (productoSeleccionadoRef.current = producto._id)}
                onMouseLeave={() => (productoSeleccionadoRef.current = null)}
              >

                
                <div className="">
                 <h3> <img src={producto.imagen} width="100px" alt="" />  {producto.nombre}</h3>
                </div>
              
               
                <div className="producto-subtotal">
                
                  <button className="btn btn-danger" onClick={() => eliminarProductoDelCarrito(producto._id)}>
                    Eliminar
                  </button>
                  <h4>Agotado desde  {producto.fechaAgregado}</h4>
                </div>
              </li>
            ))}
          
        </div>

     
      </div>
    </div>
         
        </div>
        <div className="modal-footer">
            
        </div>
      </div>
    </div>
  </div>
    )}

{modalActivo === "caribe" && (
    <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ background: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Caribe</h5>
              <button className="btn-close" onClick={() => setModalActivo(null)}></button>
       
        </div>
        <div className="modal-body">
         

 <div className="container">
      <div className="row ">
      
       <input
  ref={inputRef}
  type="text"
  placeholder="Escanee el código de barras o escribe el nombre del producto"
  value={filtro}
  onChange={handleFiltroChange}
  onKeyPress={handleKeyPress}
  onFocus={() => setMantenerFocoBusqueda(true)}
  style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
/>
<h1>Productos agotados</h1>
        
        {filtro === '' ? (
    <p></p>
  ) :productosFiltrados.length === 0 ? (
          <p>No se encontraron productos que coincidan con la busqueda</p>
        ) : (
          <div className="row">
           {productosFiltrados.map((producto, index) => {
  const esSeleccionado = indiceSeleccionado === index;

  return (
    <div key={index} className="col-12 col-lg-4">
      <div
        className={`card card-legumbre ${esSeleccionado ? 'seleccionado' : ''}`}
        style={{
          backgroundImage: `url(${producto.imagen})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '200px',
          color: esSeleccionado ? 'white' : 'black',
          position: 'relative',
          marginBottom: '20px',
          borderRadius: '10px',
          overflow: 'hidden',
          filter: esSeleccionado ? 'none' : 'brightness(1)',
          border: esSeleccionado ? '2px solid #007bff' : '1px solid #ccc',
          boxShadow: esSeleccionado ? '0 0 10px #007bff' : 'none',
        }}
      >
        <div
          className="card-body"
          style={{
            backgroundColor: esSeleccionado ? 'rgba(40, 66, 50, 0.69)' : 'rgba(134, 249, 176, 0.54)',
            height: '100%',
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <h4 className="card-title" style={{ fontWeight: 'bold' }}>{producto.nombre}</h4>
           
          

           
          </div>

          <button
            className="btn btn-primary btn-legumbre mt-2"
            onClick={() => agregarAlCarrito(producto)}
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
  );
})}

          </div>
        )}
        
        <div className="col-md-9">
          
            {carrito3.filter(producto => producto.origen === "caribe").slice().reverse().map((producto, index) => (
              <li
                key={index}
                className="producto-item"
                onMouseEnter={() => (productoSeleccionadoRef.current = producto._id)}
                onMouseLeave={() => (productoSeleccionadoRef.current = null)}
              >

                
                <div className="">
                 <h3> <img src={producto.imagen} width="100px" alt="" />  {producto.nombre}</h3>
                </div>
              
               
                <div className="producto-subtotal">
                
                  <button className="btn btn-danger" onClick={() => eliminarProductoDelCarrito(producto._id)}>
                    Eliminar
                  </button>
                  <h4>Agotado desde  {producto.fechaAgregado}</h4>
                </div>
              </li>
            ))}
          
        </div>

     
      </div>
    </div>
         
        </div>
        <div className="modal-footer">
            
        </div>
      </div>
    </div>
  </div>
    






)}
  {modalActivo === "carriel" && (
    <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ background: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Carriel</h5>
              <button className="btn-close" onClick={() => setModalActivo(null)}></button>
       
        </div>
        <div className="modal-body">
         

 <div className="container">
      <div className="row ">
      
       <input
  ref={inputRef}
  type="text"
  placeholder="Escanee el código de barras o escribe el nombre del producto"
  value={filtro}
  onChange={handleFiltroChange}
  onKeyPress={handleKeyPress}
  onFocus={() => setMantenerFocoBusqueda(true)}
  style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
/>
<h1>Productos agotados</h1>
        
        {filtro === '' ? (
    <p></p>
  ) :productosFiltrados.length === 0 ? (
          <p>No se encontraron productos que coincidan con la busqueda</p>
        ) : (
          <div className="row">
           {productosFiltrados.map((producto, index) => {
  const esSeleccionado = indiceSeleccionado === index;

  return (
    <div key={index} className="col-12 col-lg-4">
      <div
        className={`card card-legumbre ${esSeleccionado ? 'seleccionado' : ''}`}
        style={{
          backgroundImage: `url(${producto.imagen})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '200px',
          color: esSeleccionado ? 'white' : 'black',
          position: 'relative',
          marginBottom: '20px',
          borderRadius: '10px',
          overflow: 'hidden',
          filter: esSeleccionado ? 'none' : 'brightness(1)',
          border: esSeleccionado ? '2px solid #007bff' : '1px solid #ccc',
          boxShadow: esSeleccionado ? '0 0 10px #007bff' : 'none',
        }}
      >
        <div
          className="card-body"
          style={{
            backgroundColor: esSeleccionado ? 'rgba(40, 66, 50, 0.69)' : 'rgba(134, 249, 176, 0.54)',
            height: '100%',
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <h4 className="card-title" style={{ fontWeight: 'bold' }}>{producto.nombre}</h4>
           
          

           
          </div>

          <button
            className="btn btn-primary btn-legumbre mt-2"
            onClick={() => agregarAlCarrito(producto)}
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
  );
})}

          </div>
        )}
        
        <div className="col-md-9">
          
            {carrito3.filter(producto => producto.origen === "carriel").slice().reverse().map((producto, index) => (
              <li
                key={index}
                className="producto-item"
                onMouseEnter={() => (productoSeleccionadoRef.current = producto._id)}
                onMouseLeave={() => (productoSeleccionadoRef.current = null)}
              >

                
                <div className="">
                 <h3> <img src={producto.imagen} width="100px" alt="" />  {producto.nombre}</h3>
                </div>
              
               
                <div className="producto-subtotal">
                
                  <button className="btn btn-danger" onClick={() => eliminarProductoDelCarrito(producto._id)}>
                    Eliminar
                  </button>
                  <h4>Agotado desde  {producto.fechaAgregado}</h4>
                </div>
              </li>
            ))}
          
        </div>

     
      </div>
    </div>
         
        </div>
        <div className="modal-footer">
            
        </div>
      </div>
    </div>
  </div>
    )}
{modalActivo === "casangel" && (
    <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ background: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Casangel</h5>
              <button className="btn-close" onClick={() => setModalActivo(null)}></button>
       
        </div>
        <div className="modal-body">
         

 <div className="container">
      <div className="row ">
      
       <input
  ref={inputRef}
  type="text"
  placeholder="Escanee el código de barras o escribe el nombre del producto"
  value={filtro}
  onChange={handleFiltroChange}
  onKeyPress={handleKeyPress}
  onFocus={() => setMantenerFocoBusqueda(true)}
  style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
/>
<h1>Productos agotados</h1>
        
        {filtro === '' ? (
    <p></p>
  ) :productosFiltrados.length === 0 ? (
          <p>No se encontraron productos que coincidan con la busqueda</p>
        ) : (
          <div className="row">
           {productosFiltrados.map((producto, index) => {
  const esSeleccionado = indiceSeleccionado === index;

  return (
    <div key={index} className="col-12 col-lg-4">
      <div
        className={`card card-legumbre ${esSeleccionado ? 'seleccionado' : ''}`}
        style={{
          backgroundImage: `url(${producto.imagen})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '200px',
          color: esSeleccionado ? 'white' : 'black',
          position: 'relative',
          marginBottom: '20px',
          borderRadius: '10px',
          overflow: 'hidden',
          filter: esSeleccionado ? 'none' : 'brightness(1)',
          border: esSeleccionado ? '2px solid #007bff' : '1px solid #ccc',
          boxShadow: esSeleccionado ? '0 0 10px #007bff' : 'none',
        }}
      >
        <div
          className="card-body"
          style={{
            backgroundColor: esSeleccionado ? 'rgba(40, 66, 50, 0.69)' : 'rgba(134, 249, 176, 0.54)',
            height: '100%',
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <h4 className="card-title" style={{ fontWeight: 'bold' }}>{producto.nombre}</h4>
           
          

           
          </div>

          <button
            className="btn btn-primary btn-legumbre mt-2"
            onClick={() => agregarAlCarrito(producto)}
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
  );
})}

          </div>
        )}
        
        <div className="col-md-9">
          
            {carrito3.filter(producto => producto.origen === "casangel").slice().reverse().map((producto, index) => (
              <li
                key={index}
                className="producto-item"
                onMouseEnter={() => (productoSeleccionadoRef.current = producto._id)}
                onMouseLeave={() => (productoSeleccionadoRef.current = null)}
              >

                
                <div className="">
                 <h3> <img src={producto.imagen} width="100px" alt="" />  {producto.nombre}</h3>
                </div>
              
               
                <div className="producto-subtotal">
                
                  <button className="btn btn-danger" onClick={() => eliminarProductoDelCarrito(producto._id)}>
                    Eliminar
                  </button>
                  <h4>Agotado desde  {producto.fechaAgregado}</h4>
                </div>
              </li>
            ))}
          
        </div>

     
      </div>
    </div>
         
        </div>
        <div className="modal-footer">
            
        </div>
      </div>
    </div>
  </div>
    






)}
  {modalActivo === "caseritas" && (
    <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ background: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Caseritas</h5>
              <button className="btn-close" onClick={() => setModalActivo(null)}></button>
       
        </div>
        <div className="modal-body">
         

 <div className="container">
      <div className="row ">
      
       <input
  ref={inputRef}
  type="text"
  placeholder="Escanee el código de barras o escribe el nombre del producto"
  value={filtro}
  onChange={handleFiltroChange}
  onKeyPress={handleKeyPress}
  onFocus={() => setMantenerFocoBusqueda(true)}
  style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
/>
<h1>Productos agotados</h1>
        
        {filtro === '' ? (
    <p></p>
  ) :productosFiltrados.length === 0 ? (
          <p>No se encontraron productos que coincidan con la busqueda</p>
        ) : (
          <div className="row">
           {productosFiltrados.map((producto, index) => {
  const esSeleccionado = indiceSeleccionado === index;

  return (
    <div key={index} className="col-12 col-lg-4">
      <div
        className={`card card-legumbre ${esSeleccionado ? 'seleccionado' : ''}`}
        style={{
          backgroundImage: `url(${producto.imagen})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '200px',
          color: esSeleccionado ? 'white' : 'black',
          position: 'relative',
          marginBottom: '20px',
          borderRadius: '10px',
          overflow: 'hidden',
          filter: esSeleccionado ? 'none' : 'brightness(1)',
          border: esSeleccionado ? '2px solid #007bff' : '1px solid #ccc',
          boxShadow: esSeleccionado ? '0 0 10px #007bff' : 'none',
        }}
      >
        <div
          className="card-body"
          style={{
            backgroundColor: esSeleccionado ? 'rgba(40, 66, 50, 0.69)' : 'rgba(134, 249, 176, 0.54)',
            height: '100%',
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <h4 className="card-title" style={{ fontWeight: 'bold' }}>{producto.nombre}</h4>
           
          

           
          </div>

          <button
            className="btn btn-primary btn-legumbre mt-2"
            onClick={() => agregarAlCarrito(producto)}
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
  );
})}

          </div>
        )}
        
        <div className="col-md-9">
          
            {carrito3.filter(producto => producto.origen === "caseritas").slice().reverse().map((producto, index) => (
              <li
                key={index}
                className="producto-item"
                onMouseEnter={() => (productoSeleccionadoRef.current = producto._id)}
                onMouseLeave={() => (productoSeleccionadoRef.current = null)}
              >

                
                <div className="">
                 <h3> <img src={producto.imagen} width="100px" alt="" />  {producto.nombre}</h3>
                </div>
              
               
                <div className="producto-subtotal">
                
                  <button className="btn btn-danger" onClick={() => eliminarProductoDelCarrito(producto._id)}>
                    Eliminar
                  </button>
                  <h4>Agotado desde  {producto.fechaAgregado}</h4>
                </div>
              </li>
            ))}
          
        </div>

     
      </div>
    </div>
         
        </div>
        <div className="modal-footer">
            
        </div>
      </div>
    </div>
  </div>
    )}

{modalActivo === "choriunion" && (
    <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ background: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Choriunion</h5>
              <button className="btn-close" onClick={() => setModalActivo(null)}></button>
       
        </div>
        <div className="modal-body">
         

 <div className="container">
      <div className="row ">
      
       <input
  ref={inputRef}
  type="text"
  placeholder="Escanee el código de barras o escribe el nombre del producto"
  value={filtro}
  onChange={handleFiltroChange}
  onKeyPress={handleKeyPress}
  onFocus={() => setMantenerFocoBusqueda(true)}
  style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
/>
<h1>Productos agotados</h1>
        
        {filtro === '' ? (
    <p></p>
  ) :productosFiltrados.length === 0 ? (
          <p>No se encontraron productos que coincidan con la busqueda</p>
        ) : (
          <div className="row">
           {productosFiltrados.map((producto, index) => {
  const esSeleccionado = indiceSeleccionado === index;

  return (
    <div key={index} className="col-12 col-lg-4">
      <div
        className={`card card-legumbre ${esSeleccionado ? 'seleccionado' : ''}`}
        style={{
          backgroundImage: `url(${producto.imagen})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '200px',
          color: esSeleccionado ? 'white' : 'black',
          position: 'relative',
          marginBottom: '20px',
          borderRadius: '10px',
          overflow: 'hidden',
          filter: esSeleccionado ? 'none' : 'brightness(1)',
          border: esSeleccionado ? '2px solid #007bff' : '1px solid #ccc',
          boxShadow: esSeleccionado ? '0 0 10px #007bff' : 'none',
        }}
      >
        <div
          className="card-body"
          style={{
            backgroundColor: esSeleccionado ? 'rgba(40, 66, 50, 0.69)' : 'rgba(134, 249, 176, 0.54)',
            height: '100%',
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <h4 className="card-title" style={{ fontWeight: 'bold' }}>{producto.nombre}</h4>
           
          

           
          </div>

          <button
            className="btn btn-primary btn-legumbre mt-2"
            onClick={() => agregarAlCarrito(producto)}
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
  );
})}

          </div>
        )}
        
        <div className="col-md-9">
          
            {carrito3.filter(producto => producto.origen === "choriunion").slice().reverse().map((producto, index) => (
              <li
                key={index}
                className="producto-item"
                onMouseEnter={() => (productoSeleccionadoRef.current = producto._id)}
                onMouseLeave={() => (productoSeleccionadoRef.current = null)}
              >

                
                <div className="">
                 <h3> <img src={producto.imagen} width="100px" alt="" />  {producto.nombre}</h3>
                </div>
              
               
                <div className="producto-subtotal">
                
                  <button className="btn btn-danger" onClick={() => eliminarProductoDelCarrito(producto._id)}>
                    Eliminar
                  </button>
                  <h4>Agotado desde  {producto.fechaAgregado}</h4>
                </div>
              </li>
            ))}
          
        </div>

     
      </div>
    </div>
         
        </div>
        <div className="modal-footer">
            
        </div>
      </div>
    </div>
  </div>
    






)}
  {modalActivo === "cocacola" && (
    <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ background: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Cocacola</h5>
              <button className="btn-close" onClick={() => setModalActivo(null)}></button>
       
        </div>
        <div className="modal-body">
         

 <div className="container">
      <div className="row ">
      
       <input
  ref={inputRef}
  type="text"
  placeholder="Escanee el código de barras o escribe el nombre del producto"
  value={filtro}
  onChange={handleFiltroChange}
  onKeyPress={handleKeyPress}
  onFocus={() => setMantenerFocoBusqueda(true)}
  style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
/>
<h1>Productos agotados</h1>
        
        {filtro === '' ? (
    <p></p>
  ) :productosFiltrados.length === 0 ? (
          <p>No se encontraron productos que coincidan con la busqueda</p>
        ) : (
          <div className="row">
           {productosFiltrados.map((producto, index) => {
  const esSeleccionado = indiceSeleccionado === index;

  return (
    <div key={index} className="col-12 col-lg-4">
      <div
        className={`card card-legumbre ${esSeleccionado ? 'seleccionado' : ''}`}
        style={{
          backgroundImage: `url(${producto.imagen})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '200px',
          color: esSeleccionado ? 'white' : 'black',
          position: 'relative',
          marginBottom: '20px',
          borderRadius: '10px',
          overflow: 'hidden',
          filter: esSeleccionado ? 'none' : 'brightness(1)',
          border: esSeleccionado ? '2px solid #007bff' : '1px solid #ccc',
          boxShadow: esSeleccionado ? '0 0 10px #007bff' : 'none',
        }}
      >
        <div
          className="card-body"
          style={{
            backgroundColor: esSeleccionado ? 'rgba(40, 66, 50, 0.69)' : 'rgba(134, 249, 176, 0.54)',
            height: '100%',
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <h4 className="card-title" style={{ fontWeight: 'bold' }}>{producto.nombre}</h4>
           
          

           
          </div>

          <button
            className="btn btn-primary btn-legumbre mt-2"
            onClick={() => agregarAlCarrito(producto)}
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
  );
})}

          </div>
        )}
        
        <div className="col-md-9">
          
            {carrito3.filter(producto => producto.origen === "cocacola").slice().reverse().map((producto, index) => (
              <li
                key={index}
                className="producto-item"
                onMouseEnter={() => (productoSeleccionadoRef.current = producto._id)}
                onMouseLeave={() => (productoSeleccionadoRef.current = null)}
              >

                
                <div className="">
                 <h3> <img src={producto.imagen} width="100px" alt="" />  {producto.nombre}</h3>
                </div>
              
               
                <div className="producto-subtotal">
                
                  <button className="btn btn-danger" onClick={() => eliminarProductoDelCarrito(producto._id)}>
                    Eliminar
                  </button>
                  <h4>Agotado desde  {producto.fechaAgregado}</h4>
                </div>
              </li>
            ))}
          
        </div>

     
      </div>
    </div>
         
        </div>
        <div className="modal-footer">
            
        </div>
      </div>
    </div>
  </div>
    )}

{modalActivo === "colanta" && (
    <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ background: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Colanta</h5>
              <button className="btn-close" onClick={() => setModalActivo(null)}></button>
       
        </div>
        <div className="modal-body">
         

 <div className="container">
      <div className="row ">
      
       <input
  ref={inputRef}
  type="text"
  placeholder="Escanee el código de barras o escribe el nombre del producto"
  value={filtro}
  onChange={handleFiltroChange}
  onKeyPress={handleKeyPress}
  onFocus={() => setMantenerFocoBusqueda(true)}
  style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
/>
<h1>Productos agotados</h1>
        
        {filtro === '' ? (
    <p></p>
  ) :productosFiltrados.length === 0 ? (
          <p>No se encontraron productos que coincidan con la busqueda</p>
        ) : (
          <div className="row">
           {productosFiltrados.map((producto, index) => {
  const esSeleccionado = indiceSeleccionado === index;

  return (
    <div key={index} className="col-12 col-lg-4">
      <div
        className={`card  `}
     
      >
        <div
          className="card-body"
         
        >
          <div>
            <h4 className="card-title" style={{ fontWeight: 'bold' }}>{producto.nombre}</h4>
           
          

           
          </div>

          <button
            className="btn btn-primary btn-legumbre mt-2"
            onClick={() => agregarAlCarrito(producto)}
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
  );
})}

          </div>
        )}
        
        <div className="col-md-9">
          
            {carrito3.filter(producto => producto.origen === "colanta").slice().reverse().map((producto, index) => (
              <li
                key={index}
              
              >

                
                <div className="">
                 <h3> <img src={producto.imagen} width="100px" alt="" />  {producto.nombre}</h3>
                </div>
              
               
                <div className="producto-subtotal">
                
                  <button className="btn btn-danger" onClick={() => eliminarProductoDelCarrito(producto._id)}>
                    Eliminar
                  </button>
                  <h4>Agotado desde  {producto.fechaAgregado}</h4>
                </div>
              </li>
            ))}
          
        </div>

     
      </div>
    </div>
         
        </div>
        <div className="modal-footer">
            
        </div>
      </div>
    </div>
  </div>
    






)}
  {modalActivo === "colombina" && (
    <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ background: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Colombina</h5>
              <button className="btn-close" onClick={() => setModalActivo(null)}></button>
       
        </div>
        <div className="modal-body">
         

 <div className="container">
      <div className="row ">
      
       <input
  ref={inputRef}
  type="text"
  placeholder="Escanee el código de barras o escribe el nombre del producto"
  value={filtro}
  onChange={handleFiltroChange}
  onKeyPress={handleKeyPress}
  onFocus={() => setMantenerFocoBusqueda(true)}
  style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
/>
<h1>Productos agotados</h1>
        
        {filtro === '' ? (
    <p></p>
  ) :productosFiltrados.length === 0 ? (
          <p>No se encontraron productos que coincidan con la busqueda</p>
        ) : (
          <div className="row">
           {productosFiltrados.map((producto, index) => {
  const esSeleccionado = indiceSeleccionado === index;

  return (
    <div key={index} className="col-12 col-lg-4">
      <div
        className={`card card-legumbre ${esSeleccionado ? 'seleccionado' : ''}`}
        style={{
          backgroundImage: `url(${producto.imagen})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '200px',
          color: esSeleccionado ? 'white' : 'black',
          position: 'relative',
          marginBottom: '20px',
          borderRadius: '10px',
          overflow: 'hidden',
          filter: esSeleccionado ? 'none' : 'brightness(1)',
          border: esSeleccionado ? '2px solid #007bff' : '1px solid #ccc',
          boxShadow: esSeleccionado ? '0 0 10px #007bff' : 'none',
        }}
      >
        <div
          className="card-body"
          style={{
            backgroundColor: esSeleccionado ? 'rgba(40, 66, 50, 0.69)' : 'rgba(134, 249, 176, 0.54)',
            height: '100%',
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <h4 className="card-title" style={{ fontWeight: 'bold' }}>{producto.nombre}</h4>
           
          

           
          </div>

          <button
            className="btn btn-primary btn-legumbre mt-2"
            onClick={() => agregarAlCarrito(producto)}
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
  );
})}

          </div>
        )}
        
        <div className="col-md-9">
          
            {carrito3.filter(producto => producto.origen === "colombina").slice().reverse().map((producto, index) => (
              <li
                key={index}
                className="producto-item"
                onMouseEnter={() => (productoSeleccionadoRef.current = producto._id)}
                onMouseLeave={() => (productoSeleccionadoRef.current = null)}
              >

                
                <div className="">
                 <h3> <img src={producto.imagen} width="100px" alt="" />  {producto.nombre}</h3>
                </div>
              
               
                <div className="producto-subtotal">
                
                  <button className="btn btn-danger" onClick={() => eliminarProductoDelCarrito(producto._id)}>
                    Eliminar
                  </button>
                  <h4>Agotado desde  {producto.fechaAgregado}</h4>
                </div>
              </li>
            ))}
          
        </div>

     
      </div>
    </div>
         
        </div>
        <div className="modal-footer">
            
        </div>
      </div>
    </div>
  </div>
    )}

{modalActivo === "dan" && (
    <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ background: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Dan</h5>
              <button className="btn-close" onClick={() => setModalActivo(null)}></button>
       
        </div>
        <div className="modal-body">
         

 <div className="container">
      <div className="row ">
      
       <input
  ref={inputRef}
  type="text"
  placeholder="Escanee el código de barras o escribe el nombre del producto"
  value={filtro}
  onChange={handleFiltroChange}
  onKeyPress={handleKeyPress}
  onFocus={() => setMantenerFocoBusqueda(true)}
  style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
/>
<h1>Productos agotados</h1>
        
        {filtro === '' ? (
    <p></p>
  ) :productosFiltrados.length === 0 ? (
          <p>No se encontraron productos que coincidan con la busqueda</p>
        ) : (
          <div className="row">
           {productosFiltrados.map((producto, index) => {
  const esSeleccionado = indiceSeleccionado === index;

  return (
    <div key={index} className="col-12 col-lg-4">
      <div
        className={`card card-legumbre ${esSeleccionado ? 'seleccionado' : ''}`}
        style={{
          backgroundImage: `url(${producto.imagen})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '200px',
          color: esSeleccionado ? 'white' : 'black',
          position: 'relative',
          marginBottom: '20px',
          borderRadius: '10px',
          overflow: 'hidden',
          filter: esSeleccionado ? 'none' : 'brightness(1)',
          border: esSeleccionado ? '2px solid #007bff' : '1px solid #ccc',
          boxShadow: esSeleccionado ? '0 0 10px #007bff' : 'none',
        }}
      >
        <div
          className="card-body"
          style={{
            backgroundColor: esSeleccionado ? 'rgba(40, 66, 50, 0.69)' : 'rgba(134, 249, 176, 0.54)',
            height: '100%',
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <h4 className="card-title" style={{ fontWeight: 'bold' }}>{producto.nombre}</h4>
           
          

           
          </div>

          <button
            className="btn btn-primary btn-legumbre mt-2"
            onClick={() => agregarAlCarrito(producto)}
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
  );
})}

          </div>
        )}
        
        <div className="col-md-9">
          
            {carrito3.filter(producto => producto.origen === "dan").slice().reverse().map((producto, index) => (
              <li
                key={index}
                className="producto-item"
                onMouseEnter={() => (productoSeleccionadoRef.current = producto._id)}
                onMouseLeave={() => (productoSeleccionadoRef.current = null)}
              >

                
                <div className="">
                 <h3> <img src={producto.imagen} width="100px" alt="" />  {producto.nombre}</h3>
                </div>
              
               
                <div className="producto-subtotal">
                
                  <button className="btn btn-danger" onClick={() => eliminarProductoDelCarrito(producto._id)}>
                    Eliminar
                  </button>
                  <h4>Agotado desde  {producto.fechaAgregado}</h4>
                </div>
              </li>
            ))}
          
        </div>

     
      </div>
    </div>
         
        </div>
        <div className="modal-footer">
            
        </div>
      </div>
    </div>
  </div>
    






)}
  {modalActivo === "dg" && (
    <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ background: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Dg</h5>
              <button className="btn-close" onClick={() => setModalActivo(null)}></button>
       
        </div>
        <div className="modal-body">
         

 <div className="container">
      <div className="row ">
      
       <input
  ref={inputRef}
  type="text"
  placeholder="Escanee el código de barras o escribe el nombre del producto"
  value={filtro}
  onChange={handleFiltroChange}
  onKeyPress={handleKeyPress}
  onFocus={() => setMantenerFocoBusqueda(true)}
  style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
/>
<h1>Productos agotados</h1>
        
        {filtro === '' ? (
    <p></p>
  ) :productosFiltrados.length === 0 ? (
          <p>No se encontraron productos que coincidan con la busqueda</p>
        ) : (
          <div className="row">
           {productosFiltrados.map((producto, index) => {
  const esSeleccionado = indiceSeleccionado === index;

  return (
    <div key={index} className="col-12 col-lg-4">
      <div
        className={`card card-legumbre ${esSeleccionado ? 'seleccionado' : ''}`}
        style={{
          backgroundImage: `url(${producto.imagen})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '200px',
          color: esSeleccionado ? 'white' : 'black',
          position: 'relative',
          marginBottom: '20px',
          borderRadius: '10px',
          overflow: 'hidden',
          filter: esSeleccionado ? 'none' : 'brightness(1)',
          border: esSeleccionado ? '2px solid #007bff' : '1px solid #ccc',
          boxShadow: esSeleccionado ? '0 0 10px #007bff' : 'none',
        }}
      >
        <div
          className="card-body"
          style={{
            backgroundColor: esSeleccionado ? 'rgba(40, 66, 50, 0.69)' : 'rgba(134, 249, 176, 0.54)',
            height: '100%',
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <h4 className="card-title" style={{ fontWeight: 'bold' }}>{producto.nombre}</h4>
           
          

           
          </div>

          <button
            className="btn btn-primary btn-legumbre mt-2"
            onClick={() => agregarAlCarrito(producto)}
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
  );
})}

          </div>
        )}
        
        <div className="col-md-9">
          
            {carrito3.filter(producto => producto.origen === "dg").slice().reverse().map((producto, index) => (
              <li
                key={index}
                className="producto-item"
                onMouseEnter={() => (productoSeleccionadoRef.current = producto._id)}
                onMouseLeave={() => (productoSeleccionadoRef.current = null)}
              >

                
                <div className="">
                 <h3> <img src={producto.imagen} width="100px" alt="" />  {producto.nombre}</h3>
                </div>
              
               
                <div className="producto-subtotal">
                
                  <button className="btn btn-danger" onClick={() => eliminarProductoDelCarrito(producto._id)}>
                    Eliminar
                  </button>
                  <h4>Agotado desde  {producto.fechaAgregado}</h4>
                </div>
              </li>
            ))}
          
        </div>

     
      </div>
    </div>
         
        </div>
        <div className="modal-footer">
            
        </div>
      </div>
    </div>
  </div>
    )}
 {modalActivo === "distiendas" && (
    <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ background: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Distiendas</h5>
              <button className="btn-close" onClick={() => setModalActivo(null)}></button>
       
        </div>
        <div className="modal-body">
         

 <div className="container">
      <div className="row ">
      
       <input
  ref={inputRef}
  type="text"
  placeholder="Escanee el código de barras o escribe el nombre del producto"
  value={filtro}
  onChange={handleFiltroChange}
  onKeyPress={handleKeyPress}
  onFocus={() => setMantenerFocoBusqueda(true)}
  style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
/>
<h1>Productos agotados</h1>
        
        {filtro === '' ? (
    <p></p>
  ) :productosFiltrados.length === 0 ? (
          <p>No se encontraron productos que coincidan con la busqueda</p>
        ) : (
          <div className="row">
           {productosFiltrados.map((producto, index) => {
  const esSeleccionado = indiceSeleccionado === index;

  return (
    <div key={index} className="col-12 col-lg-4">
      <div
        className={`card card-legumbre ${esSeleccionado ? 'seleccionado' : ''}`}
        style={{
          backgroundImage: `url(${producto.imagen})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '200px',
          color: esSeleccionado ? 'white' : 'black',
          position: 'relative',
          marginBottom: '20px',
          borderRadius: '10px',
          overflow: 'hidden',
          filter: esSeleccionado ? 'none' : 'brightness(1)',
          border: esSeleccionado ? '2px solid #007bff' : '1px solid #ccc',
          boxShadow: esSeleccionado ? '0 0 10px #007bff' : 'none',
        }}
      >
        <div
          className="card-body"
          style={{
            backgroundColor: esSeleccionado ? 'rgba(40, 66, 50, 0.69)' : 'rgba(134, 249, 176, 0.54)',
            height: '100%',
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <h4 className="card-title" style={{ fontWeight: 'bold' }}>{producto.nombre}</h4>
           
          

           
          </div>

          <button
            className="btn btn-primary btn-legumbre mt-2"
            onClick={() => agregarAlCarrito(producto)}
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
  );
})}

          </div>
        )}
        
        <div className="col-md-9">
          
            {carrito3.filter(producto => producto.origen === "distiendas").slice().reverse().map((producto, index) => (
              <li
                key={index}
                className="producto-item"
                onMouseEnter={() => (productoSeleccionadoRef.current = producto._id)}
                onMouseLeave={() => (productoSeleccionadoRef.current = null)}
              >

                
                <div className="">
                 <h3> <img src={producto.imagen} width="100px" alt="" />  {producto.nombre}</h3>
                </div>
              
               
                <div className="producto-subtotal">
                
                  <button className="btn btn-danger" onClick={() => eliminarProductoDelCarrito(producto._id)}>
                    Eliminar
                  </button>
                  <h4>Agotado desde  {producto.fechaAgregado}</h4>
                </div>
              </li>
            ))}
          
        </div>

     
      </div>
    </div>
         
        </div>
        <div className="modal-footer">
            
        </div>
      </div>
    </div>
  </div>
    






)}
  {modalActivo === "distrimarcas" && (
    <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ background: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Distrimarcas</h5>
              <button className="btn-close" onClick={() => setModalActivo(null)}></button>
       
        </div>
        <div className="modal-body">
         

 <div className="container">
      <div className="row ">
      
       <input
  ref={inputRef}
  type="text"
  placeholder="Escanee el código de barras o escribe el nombre del producto"
  value={filtro}
  onChange={handleFiltroChange}
  onKeyPress={handleKeyPress}
  onFocus={() => setMantenerFocoBusqueda(true)}
  style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
/>
<h1>Productos agotados</h1>
        
        {filtro === '' ? (
    <p></p>
  ) :productosFiltrados.length === 0 ? (
          <p>No se encontraron productos que coincidan con la busqueda</p>
        ) : (
          <div className="row">
           {productosFiltrados.map((producto, index) => {
  const esSeleccionado = indiceSeleccionado === index;

  return (
    <div key={index} className="col-12 col-lg-4">
      <div
        className={`card card-legumbre ${esSeleccionado ? 'seleccionado' : ''}`}
        style={{
          backgroundImage: `url(${producto.imagen})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '200px',
          color: esSeleccionado ? 'white' : 'black',
          position: 'relative',
          marginBottom: '20px',
          borderRadius: '10px',
          overflow: 'hidden',
          filter: esSeleccionado ? 'none' : 'brightness(1)',
          border: esSeleccionado ? '2px solid #007bff' : '1px solid #ccc',
          boxShadow: esSeleccionado ? '0 0 10px #007bff' : 'none',
        }}
      >
        <div
          className="card-body"
          style={{
            backgroundColor: esSeleccionado ? 'rgba(40, 66, 50, 0.69)' : 'rgba(134, 249, 176, 0.54)',
            height: '100%',
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <h4 className="card-title" style={{ fontWeight: 'bold' }}>{producto.nombre}</h4>
           
          

           
          </div>

          <button
            className="btn btn-primary btn-legumbre mt-2"
            onClick={() => agregarAlCarrito(producto)}
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
  );
})}

          </div>
        )}
        
        <div className="col-md-9">
          
            {carrito3.filter(producto => producto.origen === "distrimarcas").slice().reverse().map((producto, index) => (
              <li
                key={index}
                className="producto-item"
                onMouseEnter={() => (productoSeleccionadoRef.current = producto._id)}
                onMouseLeave={() => (productoSeleccionadoRef.current = null)}
              >

                
                <div className="">
                 <h3> <img src={producto.imagen} width="100px" alt="" />  {producto.nombre}</h3>
                </div>
              
               
                <div className="producto-subtotal">
                
                  <button className="btn btn-danger" onClick={() => eliminarProductoDelCarrito(producto._id)}>
                    Eliminar
                  </button>
                  <h4>Agotado desde  {producto.fechaAgregado}</h4>
                </div>
              </li>
            ))}
          
        </div>

     
      </div>
    </div>
         
        </div>
        <div className="modal-footer">
            
        </div>
      </div>
    </div>
  </div>
    )}

{modalActivo === "dorado" && (
    <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ background: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Dorado</h5>
              <button className="btn-close" onClick={() => setModalActivo(null)}></button>
       
        </div>
        <div className="modal-body">
         

 <div className="container">
      <div className="row ">
      
       <input
  ref={inputRef}
  type="text"
  placeholder="Escanee el código de barras o escribe el nombre del producto"
  value={filtro}
  onChange={handleFiltroChange}
  onKeyPress={handleKeyPress}
  onFocus={() => setMantenerFocoBusqueda(true)}
  style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
/>
<h1>Productos agotados</h1>
        
        {filtro === '' ? (
    <p></p>
  ) :productosFiltrados.length === 0 ? (
          <p>No se encontraron productos que coincidan con la busqueda</p>
        ) : (
          <div className="row">
           {productosFiltrados.map((producto, index) => {
  const esSeleccionado = indiceSeleccionado === index;

  return (
    <div key={index} className="col-12 col-lg-4">
      <div
        className={`card card-legumbre ${esSeleccionado ? 'seleccionado' : ''}`}
        style={{
          backgroundImage: `url(${producto.imagen})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '200px',
          color: esSeleccionado ? 'white' : 'black',
          position: 'relative',
          marginBottom: '20px',
          borderRadius: '10px',
          overflow: 'hidden',
          filter: esSeleccionado ? 'none' : 'brightness(1)',
          border: esSeleccionado ? '2px solid #007bff' : '1px solid #ccc',
          boxShadow: esSeleccionado ? '0 0 10px #007bff' : 'none',
        }}
      >
        <div
          className="card-body"
          style={{
            backgroundColor: esSeleccionado ? 'rgba(40, 66, 50, 0.69)' : 'rgba(134, 249, 176, 0.54)',
            height: '100%',
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <h4 className="card-title" style={{ fontWeight: 'bold' }}>{producto.nombre}</h4>
           
          

           
          </div>

          <button
            className="btn btn-primary btn-legumbre mt-2"
            onClick={() => agregarAlCarrito(producto)}
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
  );
})}

          </div>
        )}
        
        <div className="col-md-9">
          
            {carrito3.filter(producto => producto.origen === "dorado").slice().reverse().map((producto, index) => (
              <li
                key={index}
                className="producto-item"
                onMouseEnter={() => (productoSeleccionadoRef.current = producto._id)}
                onMouseLeave={() => (productoSeleccionadoRef.current = null)}
              >

                
                <div className="">
                 <h3> <img src={producto.imagen} width="100px" alt="" />  {producto.nombre}</h3>
                </div>
              
               
                <div className="producto-subtotal">
                
                  <button className="btn btn-danger" onClick={() => eliminarProductoDelCarrito(producto._id)}>
                    Eliminar
                  </button>
                  <h4>Agotado desde  {producto.fechaAgregado}</h4>
                </div>
              </li>
            ))}
          
        </div>

     
      </div>
    </div>
         
        </div>
        <div className="modal-footer">
            
        </div>
      </div>
    </div>
  </div>
    






)}
  {modalActivo === "epa" && (
    <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ background: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Epa</h5>
              <button className="btn-close" onClick={() => setModalActivo(null)}></button>
       
        </div>
        <div className="modal-body">
         

 <div className="container">
      <div className="row ">
      
       <input
  ref={inputRef}
  type="text"
  placeholder="Escanee el código de barras o escribe el nombre del producto"
  value={filtro}
  onChange={handleFiltroChange}
  onKeyPress={handleKeyPress}
  onFocus={() => setMantenerFocoBusqueda(true)}
  style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
/>
<h1>Productos agotados</h1>
        
        {filtro === '' ? (
    <p></p>
  ) :productosFiltrados.length === 0 ? (
          <p>No se encontraron productos que coincidan con la busqueda</p>
        ) : (
          <div className="row">
           {productosFiltrados.map((producto, index) => {
  const esSeleccionado = indiceSeleccionado === index;

  return (
    <div key={index} className="col-12 col-lg-4">
      <div
        className={`card card-legumbre ${esSeleccionado ? 'seleccionado' : ''}`}
        style={{
          backgroundImage: `url(${producto.imagen})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '200px',
          color: esSeleccionado ? 'white' : 'black',
          position: 'relative',
          marginBottom: '20px',
          borderRadius: '10px',
          overflow: 'hidden',
          filter: esSeleccionado ? 'none' : 'brightness(1)',
          border: esSeleccionado ? '2px solid #007bff' : '1px solid #ccc',
          boxShadow: esSeleccionado ? '0 0 10px #007bff' : 'none',
        }}
      >
        <div
          className="card-body"
          style={{
            backgroundColor: esSeleccionado ? 'rgba(40, 66, 50, 0.69)' : 'rgba(134, 249, 176, 0.54)',
            height: '100%',
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <h4 className="card-title" style={{ fontWeight: 'bold' }}>{producto.nombre}</h4>
           
          

           
          </div>

          <button
            className="btn btn-primary btn-legumbre mt-2"
            onClick={() => agregarAlCarrito(producto)}
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
  );
})}

          </div>
        )}
        
        <div className="col-md-9">
          
            {carrito3.filter(producto => producto.origen === "epa").slice().reverse().map((producto, index) => (
              <li
                key={index}
                className="producto-item"
                onMouseEnter={() => (productoSeleccionadoRef.current = producto._id)}
                onMouseLeave={() => (productoSeleccionadoRef.current = null)}
              >

                
                <div className="">
                 <h3> <img src={producto.imagen} width="100px" alt="" />  {producto.nombre}</h3>
                </div>
              
               
                <div className="producto-subtotal">
                
                  <button className="btn btn-danger" onClick={() => eliminarProductoDelCarrito(producto._id)}>
                    Eliminar
                  </button>
                  <h4>Agotado desde  {producto.fechaAgregado}</h4>
                </div>
              </li>
            ))}
          
        </div>

     
      </div>
    </div>
         
        </div>
        <div className="modal-footer">
            
        </div>
      </div>
    </div>
  </div>
    )}

{modalActivo === "familia" && (
    <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ background: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Familia</h5>
              <button className="btn-close" onClick={() => setModalActivo(null)}></button>
       
        </div>
        <div className="modal-body">
         

 <div className="container">
      <div className="row ">
      
       <input
  ref={inputRef}
  type="text"
  placeholder="Escanee el código de barras o escribe el nombre del producto"
  value={filtro}
  onChange={handleFiltroChange}
  onKeyPress={handleKeyPress}
  onFocus={() => setMantenerFocoBusqueda(true)}
  style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
/>
<h1>Productos agotados</h1>
        
        {filtro === '' ? (
    <p></p>
  ) :productosFiltrados.length === 0 ? (
          <p>No se encontraron productos que coincidan con la busqueda</p>
        ) : (
          <div className="row">
           {productosFiltrados.map((producto, index) => {
  const esSeleccionado = indiceSeleccionado === index;

  return (
    <div key={index} className="col-12 col-lg-4">
      <div
        className={`card card-legumbre ${esSeleccionado ? 'seleccionado' : ''}`}
        style={{
          backgroundImage: `url(${producto.imagen})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '200px',
          color: esSeleccionado ? 'white' : 'black',
          position: 'relative',
          marginBottom: '20px',
          borderRadius: '10px',
          overflow: 'hidden',
          filter: esSeleccionado ? 'none' : 'brightness(1)',
          border: esSeleccionado ? '2px solid #007bff' : '1px solid #ccc',
          boxShadow: esSeleccionado ? '0 0 10px #007bff' : 'none',
        }}
      >
        <div
          className="card-body"
          style={{
            backgroundColor: esSeleccionado ? 'rgba(40, 66, 50, 0.69)' : 'rgba(134, 249, 176, 0.54)',
            height: '100%',
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <h4 className="card-title" style={{ fontWeight: 'bold' }}>{producto.nombre}</h4>
           
          

           
          </div>

          <button
            className="btn btn-primary btn-legumbre mt-2"
            onClick={() => agregarAlCarrito(producto)}
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
  );
})}

          </div>
        )}
        
        <div className="col-md-9">
          
            {carrito3.filter(producto => producto.origen === "familia").slice().reverse().map((producto, index) => (
              <li
                key={index}
                className="producto-item"
                onMouseEnter={() => (productoSeleccionadoRef.current = producto._id)}
                onMouseLeave={() => (productoSeleccionadoRef.current = null)}
              >

                
                <div className="">
                 <h3> <img src={producto.imagen} width="100px" alt="" />  {producto.nombre}</h3>
                </div>
              
               
                <div className="producto-subtotal">
                
                  <button className="btn btn-danger" onClick={() => eliminarProductoDelCarrito(producto._id)}>
                    Eliminar
                  </button>
                  <h4>Agotado desde  {producto.fechaAgregado}</h4>
                </div>
              </li>
            ))}
          
        </div>

     
      </div>
    </div>
         
        </div>
        <div className="modal-footer">
            
        </div>
      </div>
    </div>
  </div>
    






)}
  {modalActivo === "flor-trigo" && (
    <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ background: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Flor del trigo</h5>
              <button className="btn-close" onClick={() => setModalActivo(null)}></button>
       
        </div>
        <div className="modal-body">
         

 <div className="container">
      <div className="row ">
      
       <input
  ref={inputRef}
  type="text"
  placeholder="Escanee el código de barras o escribe el nombre del producto"
  value={filtro}
  onChange={handleFiltroChange}
  onKeyPress={handleKeyPress}
  onFocus={() => setMantenerFocoBusqueda(true)}
  style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
/>
<h1>Productos agotados</h1>
        
        {filtro === '' ? (
    <p></p>
  ) :productosFiltrados.length === 0 ? (
          <p>No se encontraron productos que coincidan con la busqueda</p>
        ) : (
          <div className="row">
           {productosFiltrados.map((producto, index) => {
  const esSeleccionado = indiceSeleccionado === index;

  return (
    <div key={index} className="col-12 col-lg-4">
      <div
        className={`card card-legumbre ${esSeleccionado ? 'seleccionado' : ''}`}
        style={{
          backgroundImage: `url(${producto.imagen})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '200px',
          color: esSeleccionado ? 'white' : 'black',
          position: 'relative',
          marginBottom: '20px',
          borderRadius: '10px',
          overflow: 'hidden',
          filter: esSeleccionado ? 'none' : 'brightness(1)',
          border: esSeleccionado ? '2px solid #007bff' : '1px solid #ccc',
          boxShadow: esSeleccionado ? '0 0 10px #007bff' : 'none',
        }}
      >
        <div
          className="card-body"
          style={{
            backgroundColor: esSeleccionado ? 'rgba(40, 66, 50, 0.69)' : 'rgba(134, 249, 176, 0.54)',
            height: '100%',
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <h4 className="card-title" style={{ fontWeight: 'bold' }}>{producto.nombre}</h4>
           
          

           
          </div>

          <button
            className="btn btn-primary btn-legumbre mt-2"
            onClick={() => agregarAlCarrito(producto)}
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
  );
})}

          </div>
        )}
        
        <div className="col-md-9">
          
            {carrito3.filter(producto => producto.origen === "flor-trigo").slice().reverse().map((producto, index) => (
              <li
                key={index}
                className="producto-item"
                onMouseEnter={() => (productoSeleccionadoRef.current = producto._id)}
                onMouseLeave={() => (productoSeleccionadoRef.current = null)}
              >

                
                <div className="">
                 <h3> <img src={producto.imagen} width="100px" alt="" />  {producto.nombre}</h3>
                </div>
              
               
                <div className="producto-subtotal">
                
                  <button className="btn btn-danger" onClick={() => eliminarProductoDelCarrito(producto._id)}>
                    Eliminar
                  </button>
                  <h4>Agotado desde  {producto.fechaAgregado}</h4>
                </div>
              </li>
            ))}
          
        </div>

     
      </div>
    </div>
         
        </div>
        <div className="modal-footer">
            
        </div>
      </div>
    </div>
  </div>
    )}


  {modalActivo === "frios-montaña" && (
    <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ background: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Frios de la montaña</h5>
              <button className="btn-close" onClick={() => setModalActivo(null)}></button>
       
        </div>
        <div className="modal-body">
         

 <div className="container">
      <div className="row ">
      
       <input
  ref={inputRef}
  type="text"
  placeholder="Escanee el código de barras o escribe el nombre del producto"
  value={filtro}
  onChange={handleFiltroChange}
  onKeyPress={handleKeyPress}
  onFocus={() => setMantenerFocoBusqueda(true)}
  style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
/>
<h1>Productos agotados</h1>
        
        {filtro === '' ? (
    <p></p>
  ) :productosFiltrados.length === 0 ? (
          <p>No se encontraron productos que coincidan con la busqueda</p>
        ) : (
          <div className="row">
           {productosFiltrados.map((producto, index) => {
  const esSeleccionado = indiceSeleccionado === index;

  return (
    <div key={index} className="col-12 col-lg-4">
      <div
        className={`card card-legumbre ${esSeleccionado ? 'seleccionado' : ''}`}
        style={{
          backgroundImage: `url(${producto.imagen})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '200px',
          color: esSeleccionado ? 'white' : 'black',
          position: 'relative',
          marginBottom: '20px',
          borderRadius: '10px',
          overflow: 'hidden',
          filter: esSeleccionado ? 'none' : 'brightness(1)',
          border: esSeleccionado ? '2px solid #007bff' : '1px solid #ccc',
          boxShadow: esSeleccionado ? '0 0 10px #007bff' : 'none',
        }}
      >
        <div
          className="card-body"
          style={{
            backgroundColor: esSeleccionado ? 'rgba(40, 66, 50, 0.69)' : 'rgba(134, 249, 176, 0.54)',
            height: '100%',
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <h4 className="card-title" style={{ fontWeight: 'bold' }}>{producto.nombre}</h4>
           
          

           
          </div>

          <button
            className="btn btn-primary btn-legumbre mt-2"
            onClick={() => agregarAlCarrito(producto)}
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
  );
})}

          </div>
        )}
        
        <div className="col-md-9">
          
            {carrito3.filter(producto => producto.origen === "frios-montaña").slice().reverse().map((producto, index) => (
              <li
                key={index}
                className="producto-item"
                onMouseEnter={() => (productoSeleccionadoRef.current = producto._id)}
                onMouseLeave={() => (productoSeleccionadoRef.current = null)}
              >

                
                <div className="">
                 <h3> <img src={producto.imagen} width="100px" alt="" />  {producto.nombre}</h3>
                </div>
              
               
                <div className="producto-subtotal">
                
                  <button className="btn btn-danger" onClick={() => eliminarProductoDelCarrito(producto._id)}>
                    Eliminar
                  </button>
                  <h4>Agotado desde  {producto.fechaAgregado}</h4>
                </div>
              </li>
            ))}
          
        </div>

     
      </div>
    </div>
         
        </div>
        <div className="modal-footer">
            
        </div>
      </div>
    </div>
  </div>
    )}

{modalActivo === "fricar" && (
    <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ background: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Fricar</h5>
              <button className="btn-close" onClick={() => setModalActivo(null)}></button>
       
        </div>
        <div className="modal-body">
         

 <div className="container">
      <div className="row ">
      
       <input
  ref={inputRef}
  type="text"
  placeholder="Escanee el código de barras o escribe el nombre del producto"
  value={filtro}
  onChange={handleFiltroChange}
  onKeyPress={handleKeyPress}
  onFocus={() => setMantenerFocoBusqueda(true)}
  style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
/>
<h1>Productos agotados</h1>
        
        {filtro === '' ? (
    <p></p>
  ) :productosFiltrados.length === 0 ? (
          <p>No se encontraron productos que coincidan con la busqueda</p>
        ) : (
          <div className="row">
           {productosFiltrados.map((producto, index) => {
  const esSeleccionado = indiceSeleccionado === index;

  return (
    <div key={index} className="col-12 col-lg-4">
      <div
        className={`card card-legumbre ${esSeleccionado ? 'seleccionado' : ''}`}
        style={{
          backgroundImage: `url(${producto.imagen})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '200px',
          color: esSeleccionado ? 'white' : 'black',
          position: 'relative',
          marginBottom: '20px',
          borderRadius: '10px',
          overflow: 'hidden',
          filter: esSeleccionado ? 'none' : 'brightness(1)',
          border: esSeleccionado ? '2px solid #007bff' : '1px solid #ccc',
          boxShadow: esSeleccionado ? '0 0 10px #007bff' : 'none',
        }}
      >
        <div
          className="card-body"
          style={{
            backgroundColor: esSeleccionado ? 'rgba(40, 66, 50, 0.69)' : 'rgba(134, 249, 176, 0.54)',
            height: '100%',
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <h4 className="card-title" style={{ fontWeight: 'bold' }}>{producto.nombre}</h4>
           
          

           
          </div>

          <button
            className="btn btn-primary btn-legumbre mt-2"
            onClick={() => agregarAlCarrito(producto)}
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
  );
})}

          </div>
        )}
        
        <div className="col-md-9">
          
            {carrito3.filter(producto => producto.origen === "fricar").slice().reverse().map((producto, index) => (
              <li
                key={index}
                className="producto-item"
                onMouseEnter={() => (productoSeleccionadoRef.current = producto._id)}
                onMouseLeave={() => (productoSeleccionadoRef.current = null)}
              >

                
                <div className="">
                 <h3> <img src={producto.imagen} width="100px" alt="" />  {producto.nombre}</h3>
                </div>
              
               
                <div className="producto-subtotal">
                
                  <button className="btn btn-danger" onClick={() => eliminarProductoDelCarrito(producto._id)}>
                    Eliminar
                  </button>
                  <h4>Agotado desde  {producto.fechaAgregado}</h4>
                </div>
              </li>
            ))}
          
        </div>

     
      </div>
    </div>
         
        </div>
        <div className="modal-footer">
            
        </div>
      </div>
    </div>
  </div>
    






)}
  {modalActivo === "frito-lay" && (
    <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ background: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Frito lay</h5>
              <button className="btn-close" onClick={() => setModalActivo(null)}></button>
       
        </div>
        <div className="modal-body">
         

 <div className="container">
      <div className="row ">
      
       <input
  ref={inputRef}
  type="text"
  placeholder="Escanee el código de barras o escribe el nombre del producto"
  value={filtro}
  onChange={handleFiltroChange}
  onKeyPress={handleKeyPress}
  onFocus={() => setMantenerFocoBusqueda(true)}
  style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
/>
<h1>Productos agotados</h1>
        
        {filtro === '' ? (
    <p></p>
  ) :productosFiltrados.length === 0 ? (
          <p>No se encontraron productos que coincidan con la busqueda</p>
        ) : (
          <div className="row">
           {productosFiltrados.map((producto, index) => {
  const esSeleccionado = indiceSeleccionado === index;

  return (
    <div key={index} className="col-12 col-lg-4">
      <div
        className={`card card-legumbre ${esSeleccionado ? 'seleccionado' : ''}`}
        style={{
          backgroundImage: `url(${producto.imagen})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '200px',
          color: esSeleccionado ? 'white' : 'black',
          position: 'relative',
          marginBottom: '20px',
          borderRadius: '10px',
          overflow: 'hidden',
          filter: esSeleccionado ? 'none' : 'brightness(1)',
          border: esSeleccionado ? '2px solid #007bff' : '1px solid #ccc',
          boxShadow: esSeleccionado ? '0 0 10px #007bff' : 'none',
        }}
      >
        <div
          className="card-body"
          style={{
            backgroundColor: esSeleccionado ? 'rgba(40, 66, 50, 0.69)' : 'rgba(134, 249, 176, 0.54)',
            height: '100%',
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <h4 className="card-title" style={{ fontWeight: 'bold' }}>{producto.nombre}</h4>
           
          

           
          </div>

          <button
            className="btn btn-primary btn-legumbre mt-2"
            onClick={() => agregarAlCarrito(producto)}
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
  );
})}

          </div>
        )}
        
        <div className="col-md-9">
          
            {carrito3.filter(producto => producto.origen === "frito-lay").slice().reverse().map((producto, index) => (
              <li
                key={index}
                className="producto-item"
                onMouseEnter={() => (productoSeleccionadoRef.current = producto._id)}
                onMouseLeave={() => (productoSeleccionadoRef.current = null)}
              >

                
                <div className="">
                 <h3> <img src={producto.imagen} width="100px" alt="" />  {producto.nombre}</h3>
                </div>
              
               
                <div className="producto-subtotal">
                
                  <button className="btn btn-danger" onClick={() => eliminarProductoDelCarrito(producto._id)}>
                    Eliminar
                  </button>
                  <h4>Agotado desde  {producto.fechaAgregado}</h4>
                </div>
              </li>
            ))}
          
        </div>

     
      </div>
    </div>
         
        </div>
        <div className="modal-footer">
            
        </div>
      </div>
    </div>
  </div>
    )}
{modalActivo === "gerardo" && (
    <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ background: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Gerardo</h5>
              <button className="btn-close" onClick={() => setModalActivo(null)}></button>
       
        </div>
        <div className="modal-body">
         

 <div className="container">
      <div className="row ">
      
       <input
  ref={inputRef}
  type="text"
  placeholder="Escanee el código de barras o escribe el nombre del producto"
  value={filtro}
  onChange={handleFiltroChange}
  onKeyPress={handleKeyPress}
  onFocus={() => setMantenerFocoBusqueda(true)}
  style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
/>
<h1>Productos agotados</h1>
        
        {filtro === '' ? (
    <p></p>
  ) :productosFiltrados.length === 0 ? (
          <p>No se encontraron productos que coincidan con la busqueda</p>
        ) : (
          <div className="row">
           {productosFiltrados.map((producto, index) => {
  const esSeleccionado = indiceSeleccionado === index;

  return (
    <div key={index} className="col-12 col-lg-4">
      <div
        className={`card card-legumbre ${esSeleccionado ? 'seleccionado' : ''}`}
        style={{
          backgroundImage: `url(${producto.imagen})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '200px',
          color: esSeleccionado ? 'white' : 'black',
          position: 'relative',
          marginBottom: '20px',
          borderRadius: '10px',
          overflow: 'hidden',
          filter: esSeleccionado ? 'none' : 'brightness(1)',
          border: esSeleccionado ? '2px solid #007bff' : '1px solid #ccc',
          boxShadow: esSeleccionado ? '0 0 10px #007bff' : 'none',
        }}
      >
        <div
          className="card-body"
          style={{
            backgroundColor: esSeleccionado ? 'rgba(40, 66, 50, 0.69)' : 'rgba(134, 249, 176, 0.54)',
            height: '100%',
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <h4 className="card-title" style={{ fontWeight: 'bold' }}>{producto.nombre}</h4>
           
          

           
          </div>

          <button
            className="btn btn-primary btn-legumbre mt-2"
            onClick={() => agregarAlCarrito(producto)}
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
  );
})}

          </div>
        )}
        
        <div className="col-md-9">
          
            {carrito3.filter(producto => producto.origen === "gerardo").slice().reverse().map((producto, index) => (
              <li
                key={index}
                className="producto-item"
                onMouseEnter={() => (productoSeleccionadoRef.current = producto._id)}
                onMouseLeave={() => (productoSeleccionadoRef.current = null)}
              >

                
                <div className="">
                 <h3> <img src={producto.imagen} width="100px" alt="" />  {producto.nombre}</h3>
                </div>
              
               
                <div className="producto-subtotal">
                
                  <button className="btn btn-danger" onClick={() => eliminarProductoDelCarrito(producto._id)}>
                    Eliminar
                  </button>
                  <h4>Agotado desde  {producto.fechaAgregado}</h4>
                </div>
              </li>
            ))}
          
        </div>

     
      </div>
    </div>
         
        </div>
        <div className="modal-footer">
            
        </div>
      </div>
    </div>
  </div>
    






)}
  {modalActivo === "granja" && (
    <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ background: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Granja</h5>
              <button className="btn-close" onClick={() => setModalActivo(null)}></button>
       
        </div>
        <div className="modal-body">
         

 <div className="container">
      <div className="row ">
      
       <input
  ref={inputRef}
  type="text"
  placeholder="Escanee el código de barras o escribe el nombre del producto"
  value={filtro}
  onChange={handleFiltroChange}
  onKeyPress={handleKeyPress}
  onFocus={() => setMantenerFocoBusqueda(true)}
  style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
/>
<h1>Productos agotados</h1>
        
        {filtro === '' ? (
    <p></p>
  ) :productosFiltrados.length === 0 ? (
          <p>No se encontraron productos que coincidan con la busqueda</p>
        ) : (
          <div className="row">
           {productosFiltrados.map((producto, index) => {
  const esSeleccionado = indiceSeleccionado === index;

  return (
    <div key={index} className="col-12 col-lg-4">
      <div
        className={`card card-legumbre ${esSeleccionado ? 'seleccionado' : ''}`}
        style={{
          backgroundImage: `url(${producto.imagen})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '200px',
          color: esSeleccionado ? 'white' : 'black',
          position: 'relative',
          marginBottom: '20px',
          borderRadius: '10px',
          overflow: 'hidden',
          filter: esSeleccionado ? 'none' : 'brightness(1)',
          border: esSeleccionado ? '2px solid #007bff' : '1px solid #ccc',
          boxShadow: esSeleccionado ? '0 0 10px #007bff' : 'none',
        }}
      >
        <div
          className="card-body"
          style={{
            backgroundColor: esSeleccionado ? 'rgba(40, 66, 50, 0.69)' : 'rgba(134, 249, 176, 0.54)',
            height: '100%',
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <h4 className="card-title" style={{ fontWeight: 'bold' }}>{producto.nombre}</h4>
           
          

           
          </div>

          <button
            className="btn btn-primary btn-legumbre mt-2"
            onClick={() => agregarAlCarrito(producto)}
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
  );
})}

          </div>
        )}
        
        <div className="col-md-9">
          
            {carrito3.filter(producto => producto.origen === "granja").slice().reverse().map((producto, index) => (
              <li
                key={index}
                className="producto-item"
                onMouseEnter={() => (productoSeleccionadoRef.current = producto._id)}
                onMouseLeave={() => (productoSeleccionadoRef.current = null)}
              >

                
                <div className="">
                 <h3> <img src={producto.imagen} width="100px" alt="" />  {producto.nombre}</h3>
                </div>
              
               
                <div className="producto-subtotal">
                
                  <button className="btn btn-danger" onClick={() => eliminarProductoDelCarrito(producto._id)}>
                    Eliminar
                  </button>
                  <h4>Agotado desde  {producto.fechaAgregado}</h4>
                </div>
              </li>
            ))}
          
        </div>

     
      </div>
    </div>
         
        </div>
        <div className="modal-footer">
            
        </div>
      </div>
    </div>
  </div>
    )}

{modalActivo === "gyg" && (
    <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ background: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">G y G</h5>
              <button className="btn-close" onClick={() => setModalActivo(null)}></button>
       
        </div>
        <div className="modal-body">
         

 <div className="container">
      <div className="row ">
      
       <input
  ref={inputRef}
  type="text"
  placeholder="Escanee el código de barras o escribe el nombre del producto"
  value={filtro}
  onChange={handleFiltroChange}
  onKeyPress={handleKeyPress}
  onFocus={() => setMantenerFocoBusqueda(true)}
  style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
/>
<h1>Productos agotados</h1>
        
        {filtro === '' ? (
    <p></p>
  ) :productosFiltrados.length === 0 ? (
          <p>No se encontraron productos que coincidan con la busqueda</p>
        ) : (
          <div className="row">
           {productosFiltrados.map((producto, index) => {
  const esSeleccionado = indiceSeleccionado === index;

  return (
    <div key={index} className="col-12 col-lg-4">
      <div
        className={`card card-legumbre ${esSeleccionado ? 'seleccionado' : ''}`}
        style={{
          backgroundImage: `url(${producto.imagen})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '200px',
          color: esSeleccionado ? 'white' : 'black',
          position: 'relative',
          marginBottom: '20px',
          borderRadius: '10px',
          overflow: 'hidden',
          filter: esSeleccionado ? 'none' : 'brightness(1)',
          border: esSeleccionado ? '2px solid #007bff' : '1px solid #ccc',
          boxShadow: esSeleccionado ? '0 0 10px #007bff' : 'none',
        }}
      >
        <div
          className="card-body"
          style={{
            backgroundColor: esSeleccionado ? 'rgba(40, 66, 50, 0.69)' : 'rgba(134, 249, 176, 0.54)',
            height: '100%',
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <h4 className="card-title" style={{ fontWeight: 'bold' }}>{producto.nombre}</h4>
           
          

           
          </div>

          <button
            className="btn btn-primary btn-legumbre mt-2"
            onClick={() => agregarAlCarrito(producto)}
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
  );
})}

          </div>
        )}
        
        <div className="col-md-9">
          
            {carrito3.filter(producto => producto.origen === "gyg").slice().reverse().map((producto, index) => (
              <li
                key={index}
                className="producto-item"
                onMouseEnter={() => (productoSeleccionadoRef.current = producto._id)}
                onMouseLeave={() => (productoSeleccionadoRef.current = null)}
              >

                
                <div className="">
                 <h3> <img src={producto.imagen} width="100px" alt="" />  {producto.nombre}</h3>
                </div>
              
               
                <div className="producto-subtotal">
                
                  <button className="btn btn-danger" onClick={() => eliminarProductoDelCarrito(producto._id)}>
                    Eliminar
                  </button>
                  <h4>Agotado desde  {producto.fechaAgregado}</h4>
                </div>
              </li>
            ))}
          
        </div>

     
      </div>
    </div>
         
        </div>
        <div className="modal-footer">
            
        </div>
      </div>
    </div>
  </div>
    






)}
  {modalActivo === "jaf" && (
    <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ background: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Jaf</h5>
              <button className="btn-close" onClick={() => setModalActivo(null)}></button>
       
        </div>
        <div className="modal-body">
         

 <div className="container">
      <div className="row ">
      
       <input
  ref={inputRef}
  type="text"
  placeholder="Escanee el código de barras o escribe el nombre del producto"
  value={filtro}
  onChange={handleFiltroChange}
  onKeyPress={handleKeyPress}
  onFocus={() => setMantenerFocoBusqueda(true)}
  style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
/>
<h1>Productos agotados</h1>
        
        {filtro === '' ? (
    <p></p>
  ) :productosFiltrados.length === 0 ? (
          <p>No se encontraron productos que coincidan con la busqueda</p>
        ) : (
          <div className="row">
           {productosFiltrados.map((producto, index) => {
  const esSeleccionado = indiceSeleccionado === index;

  return (
    <div key={index} className="col-12 col-lg-4">
      <div
        className={`card card-legumbre ${esSeleccionado ? 'seleccionado' : ''}`}
        style={{
          backgroundImage: `url(${producto.imagen})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '200px',
          color: esSeleccionado ? 'white' : 'black',
          position: 'relative',
          marginBottom: '20px',
          borderRadius: '10px',
          overflow: 'hidden',
          filter: esSeleccionado ? 'none' : 'brightness(1)',
          border: esSeleccionado ? '2px solid #007bff' : '1px solid #ccc',
          boxShadow: esSeleccionado ? '0 0 10px #007bff' : 'none',
        }}
      >
        <div
          className="card-body"
          style={{
            backgroundColor: esSeleccionado ? 'rgba(40, 66, 50, 0.69)' : 'rgba(134, 249, 176, 0.54)',
            height: '100%',
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <h4 className="card-title" style={{ fontWeight: 'bold' }}>{producto.nombre}</h4>
           
          

           
          </div>

          <button
            className="btn btn-primary btn-legumbre mt-2"
            onClick={() => agregarAlCarrito(producto)}
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
  );
})}

          </div>
        )}
        
        <div className="col-md-9">
          
            {carrito3.filter(producto => producto.origen === "jaf").slice().reverse().map((producto, index) => (
              <li
                key={index}
                className="producto-item"
                onMouseEnter={() => (productoSeleccionadoRef.current = producto._id)}
                onMouseLeave={() => (productoSeleccionadoRef.current = null)}
              >

                
                <div className="">
                 <h3> <img src={producto.imagen} width="100px" alt="" />  {producto.nombre}</h3>
                </div>
              
               
                <div className="producto-subtotal">
                
                  <button className="btn btn-danger" onClick={() => eliminarProductoDelCarrito(producto._id)}>
                    Eliminar
                  </button>
                  <h4>Agotado desde  {producto.fechaAgregado}</h4>
                </div>
              </li>
            ))}
          
        </div>

     
      </div>
    </div>
         
        </div>
        <div className="modal-footer">
            
        </div>
      </div>
    </div>
  </div>
    )}

{modalActivo === "legumbres" && (
    <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ background: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Legumbre</h5>
              <button className="btn-close" onClick={() => setModalActivo(null)}></button>
       
        </div>
        <div className="modal-body">
         

 <div className="container">
      <div className="row ">
      
       <input
  ref={inputRef}
  type="text"
  placeholder="Escanee el código de barras o escribe el nombre del producto"
  value={filtro}
  onChange={handleFiltroChange}
  onKeyPress={handleKeyPress}
  onFocus={() => setMantenerFocoBusqueda(true)}
  style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
/>
<h1>Productos agotados</h1>
        
        {filtro === '' ? (
    <p></p>
  ) :productosFiltrados.length === 0 ? (
          <p>No se encontraron productos que coincidan con la busqueda</p>
        ) : (
          <div className="row">
           {productosFiltrados.map((producto, index) => {
  const esSeleccionado = indiceSeleccionado === index;

  return (
    <div key={index} className="col-12 col-lg-4">
      <div
        className={`card card-legumbre ${esSeleccionado ? 'seleccionado' : ''}`}
        style={{
          backgroundImage: `url(${producto.imagen})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '200px',
          color: esSeleccionado ? 'white' : 'black',
          position: 'relative',
          marginBottom: '20px',
          borderRadius: '10px',
          overflow: 'hidden',
          filter: esSeleccionado ? 'none' : 'brightness(1)',
          border: esSeleccionado ? '2px solid #007bff' : '1px solid #ccc',
          boxShadow: esSeleccionado ? '0 0 10px #007bff' : 'none',
        }}
      >
        <div
          className="card-body"
          style={{
            backgroundColor: esSeleccionado ? 'rgba(40, 66, 50, 0.69)' : 'rgba(134, 249, 176, 0.54)',
            height: '100%',
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <h4 className="card-title" style={{ fontWeight: 'bold' }}>{producto.nombre}</h4>
           
          

           
          </div>

          <button
            className="btn btn-primary btn-legumbre mt-2"
            onClick={() => agregarAlCarrito(producto)}
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
  );
})}

          </div>
        )}
        
        <div className="col-md-9">
          
            {carrito3.filter(producto => producto.origen === "legumbres").slice().reverse().map((producto, index) => (
              <li
                key={index}
                className="producto-item"
                onMouseEnter={() => (productoSeleccionadoRef.current = producto._id)}
                onMouseLeave={() => (productoSeleccionadoRef.current = null)}
              >

                
                <div className="">
                 <h3> <img src={producto.imagen} width="100px" alt="" />  {producto.nombre}</h3>
                </div>
              
               
                <div className="producto-subtotal">
                
                  <button className="btn btn-danger" onClick={() => eliminarProductoDelCarrito(producto._id)}>
                    Eliminar
                  </button>
                  <h4>Agotado desde  {producto.fechaAgregado}</h4>
                </div>
              </li>
            ))}
          
        </div>

     
      </div>
    </div>
         
        </div>
        <div className="modal-footer">
            
        </div>
      </div>
    </div>
  </div>
    






)}
  {modalActivo === "mercaventas" && (
    <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ background: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Mercaventas</h5>
              <button className="btn-close" onClick={() => setModalActivo(null)}></button>
       
        </div>
        <div className="modal-body">
         

 <div className="container">
      <div className="row ">
      
       <input
  ref={inputRef}
  type="text"
  placeholder="Escanee el código de barras o escribe el nombre del producto"
  value={filtro}
  onChange={handleFiltroChange}
  onKeyPress={handleKeyPress}
  onFocus={() => setMantenerFocoBusqueda(true)}
  style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
/>
<h1>Productos agotados</h1>
        
        {filtro === '' ? (
    <p></p>
  ) :productosFiltrados.length === 0 ? (
          <p>No se encontraron productos que coincidan con la busqueda</p>
        ) : (
          <div className="row">
           {productosFiltrados.map((producto, index) => {
  const esSeleccionado = indiceSeleccionado === index;

  return (
    <div key={index} className="col-12 col-lg-4">
      <div
        className={`card card-legumbre ${esSeleccionado ? 'seleccionado' : ''}`}
        style={{
          backgroundImage: `url(${producto.imagen})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '200px',
          color: esSeleccionado ? 'white' : 'black',
          position: 'relative',
          marginBottom: '20px',
          borderRadius: '10px',
          overflow: 'hidden',
          filter: esSeleccionado ? 'none' : 'brightness(1)',
          border: esSeleccionado ? '2px solid #007bff' : '1px solid #ccc',
          boxShadow: esSeleccionado ? '0 0 10px #007bff' : 'none',
        }}
      >
        <div
          className="card-body"
          style={{
            backgroundColor: esSeleccionado ? 'rgba(40, 66, 50, 0.69)' : 'rgba(134, 249, 176, 0.54)',
            height: '100%',
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <h4 className="card-title" style={{ fontWeight: 'bold' }}>{producto.nombre}</h4>
           
          

           
          </div>

          <button
            className="btn btn-primary btn-legumbre mt-2"
            onClick={() => agregarAlCarrito(producto)}
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
  );
})}

          </div>
        )}
        
        <div className="col-md-9">
          
            {carrito3.filter(producto => producto.origen === "mercaventas").slice().reverse().map((producto, index) => (
              <li
                key={index}
                className="producto-item"
                onMouseEnter={() => (productoSeleccionadoRef.current = producto._id)}
                onMouseLeave={() => (productoSeleccionadoRef.current = null)}
              >

                
                <div className="">
                 <h3> <img src={producto.imagen} width="100px" alt="" />  {producto.nombre}</h3>
                </div>
              
               
                <div className="producto-subtotal">
                
                  <button className="btn btn-danger" onClick={() => eliminarProductoDelCarrito(producto._id)}>
                    Eliminar
                  </button>
                  <h4>Agotado desde  {producto.fechaAgregado}</h4>
                </div>
              </li>
            ))}
          
        </div>

     
      </div>
    </div>
         
        </div>
        <div className="modal-footer">
            
        </div>
      </div>
    </div>
  </div>
    )}

{modalActivo === "mygcondimentos" && (
    <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ background: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">M&G condimentos</h5>
              <button className="btn-close" onClick={() => setModalActivo(null)}></button>
       
        </div>
        <div className="modal-body">
         

 <div className="container">
      <div className="row ">
      
       <input
  ref={inputRef}
  type="text"
  placeholder="Escanee el código de barras o escribe el nombre del producto"
  value={filtro}
  onChange={handleFiltroChange}
  onKeyPress={handleKeyPress}
  onFocus={() => setMantenerFocoBusqueda(true)}
  style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
/>
<h1>Productos agotados</h1>
        
        {filtro === '' ? (
    <p></p>
  ) :productosFiltrados.length === 0 ? (
          <p>No se encontraron productos que coincidan con la busqueda</p>
        ) : (
          <div className="row">
           {productosFiltrados.map((producto, index) => {
  const esSeleccionado = indiceSeleccionado === index;

  return (
    <div key={index} className="col-12 col-lg-4">
      <div
        className={`card card-legumbre ${esSeleccionado ? 'seleccionado' : ''}`}
        style={{
          backgroundImage: `url(${producto.imagen})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '200px',
          color: esSeleccionado ? 'white' : 'black',
          position: 'relative',
          marginBottom: '20px',
          borderRadius: '10px',
          overflow: 'hidden',
          filter: esSeleccionado ? 'none' : 'brightness(1)',
          border: esSeleccionado ? '2px solid #007bff' : '1px solid #ccc',
          boxShadow: esSeleccionado ? '0 0 10px #007bff' : 'none',
        }}
      >
        <div
          className="card-body"
          style={{
            backgroundColor: esSeleccionado ? 'rgba(40, 66, 50, 0.69)' : 'rgba(134, 249, 176, 0.54)',
            height: '100%',
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <h4 className="card-title" style={{ fontWeight: 'bold' }}>{producto.nombre}</h4>
           
          

           
          </div>

          <button
            className="btn btn-primary btn-legumbre mt-2"
            onClick={() => agregarAlCarrito(producto)}
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
  );
})}

          </div>
        )}
        
        <div className="col-md-9">
          
            {carrito3.filter(producto => producto.origen === "mygcondimentos").slice().reverse().map((producto, index) => (
              <li
                key={index}
                className="producto-item"
                onMouseEnter={() => (productoSeleccionadoRef.current = producto._id)}
                onMouseLeave={() => (productoSeleccionadoRef.current = null)}
              >

                
                <div className="">
                 <h3> <img src={producto.imagen} width="100px" alt="" />  {producto.nombre}</h3>
                </div>
              
               
                <div className="producto-subtotal">
                
                  <button className="btn btn-danger" onClick={() => eliminarProductoDelCarrito(producto._id)}>
                    Eliminar
                  </button>
                  <h4>Agotado desde  {producto.fechaAgregado}</h4>
                </div>
              </li>
            ))}
          
        </div>

     
      </div>
    </div>
         
        </div>
        <div className="modal-footer">
            
        </div>
      </div>
    </div>
  </div>
    






)}
  {modalActivo === "nestle" && (
    <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ background: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Nestle</h5>
              <button className="btn-close" onClick={() => setModalActivo(null)}></button>
       
        </div>
        <div className="modal-body">
         

 <div className="container">
      <div className="row ">
      
       <input
  ref={inputRef}
  type="text"
  placeholder="Escanee el código de barras o escribe el nombre del producto"
  value={filtro}
  onChange={handleFiltroChange}
  onKeyPress={handleKeyPress}
  onFocus={() => setMantenerFocoBusqueda(true)}
  style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
/>
<h1>Productos agotados</h1>
        
        {filtro === '' ? (
    <p></p>
  ) :productosFiltrados.length === 0 ? (
          <p>No se encontraron productos que coincidan con la busqueda</p>
        ) : (
          <div className="row">
           {productosFiltrados.map((producto, index) => {
  const esSeleccionado = indiceSeleccionado === index;

  return (
    <div key={index} className="col-12 col-lg-4">
      <div
        className={`card card-legumbre ${esSeleccionado ? 'seleccionado' : ''}`}
        style={{
          backgroundImage: `url(${producto.imagen})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '200px',
          color: esSeleccionado ? 'white' : 'black',
          position: 'relative',
          marginBottom: '20px',
          borderRadius: '10px',
          overflow: 'hidden',
          filter: esSeleccionado ? 'none' : 'brightness(1)',
          border: esSeleccionado ? '2px solid #007bff' : '1px solid #ccc',
          boxShadow: esSeleccionado ? '0 0 10px #007bff' : 'none',
        }}
      >
        <div
          className="card-body"
          style={{
            backgroundColor: esSeleccionado ? 'rgba(40, 66, 50, 0.69)' : 'rgba(134, 249, 176, 0.54)',
            height: '100%',
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <h4 className="card-title" style={{ fontWeight: 'bold' }}>{producto.nombre}</h4>
           
          

           
          </div>

          <button
            className="btn btn-primary btn-legumbre mt-2"
            onClick={() => agregarAlCarrito(producto)}
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
  );
})}

          </div>
        )}
        
        <div className="col-md-9">
          
            {carrito3.filter(producto => producto.origen === "nestle").slice().reverse().map((producto, index) => (
              <li
                key={index}
                className="producto-item"
                onMouseEnter={() => (productoSeleccionadoRef.current = producto._id)}
                onMouseLeave={() => (productoSeleccionadoRef.current = null)}
              >

                
                <div className="">
                 <h3> <img src={producto.imagen} width="100px" alt="" />  {producto.nombre}</h3>
                </div>
              
               
                <div className="producto-subtotal">
                
                  <button className="btn btn-danger" onClick={() => eliminarProductoDelCarrito(producto._id)}>
                    Eliminar
                  </button>
                  <h4>Agotado desde  {producto.fechaAgregado}</h4>
                </div>
              </li>
            ))}
          
        </div>

     
      </div>
    </div>
         
        </div>
        <div className="modal-footer">
            
        </div>
      </div>
    </div>
  </div>
    )}


{modalActivo === "postobon" && (
    <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ background: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Postobon</h5>
              <button className="btn-close" onClick={() => setModalActivo(null)}></button>
       
        </div>
        <div className="modal-body">
         

 <div className="container">
      <div className="row ">
      
       <input
  ref={inputRef}
  type="text"
  placeholder="Escanee el código de barras o escribe el nombre del producto"
  value={filtro}
  onChange={handleFiltroChange}
  onKeyPress={handleKeyPress}
  onFocus={() => setMantenerFocoBusqueda(true)}
  style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
/>
<h1>Productos agotados</h1>
        
        {filtro === '' ? (
    <p></p>
  ) :productosFiltrados.length === 0 ? (
          <p>No se encontraron productos que coincidan con la busqueda</p>
        ) : (
          <div className="row">
           {productosFiltrados.map((producto, index) => {
  const esSeleccionado = indiceSeleccionado === index;

  return (
    <div key={index} className="col-12 col-lg-4">
      <div
        className={`card card-legumbre ${esSeleccionado ? 'seleccionado' : ''}`}
        style={{
          backgroundImage: `url(${producto.imagen})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '200px',
          color: esSeleccionado ? 'white' : 'black',
          position: 'relative',
          marginBottom: '20px',
          borderRadius: '10px',
          overflow: 'hidden',
          filter: esSeleccionado ? 'none' : 'brightness(1)',
          border: esSeleccionado ? '2px solid #007bff' : '1px solid #ccc',
          boxShadow: esSeleccionado ? '0 0 10px #007bff' : 'none',
        }}
      >
        <div
          className="card-body"
          style={{
            backgroundColor: esSeleccionado ? 'rgba(40, 66, 50, 0.69)' : 'rgba(134, 249, 176, 0.54)',
            height: '100%',
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <h4 className="card-title" style={{ fontWeight: 'bold' }}>{producto.nombre}</h4>
           
          

           
          </div>

          <button
            className="btn btn-primary btn-legumbre mt-2"
            onClick={() => agregarAlCarrito(producto)}
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
  );
})}

          </div>
        )}
        
        <div className="col-md-9">
          
            {carrito3.filter(producto => producto.origen === "postobon").slice().reverse().map((producto, index) => (
              <li
                key={index}
                className="producto-item"
                onMouseEnter={() => (productoSeleccionadoRef.current = producto._id)}
                onMouseLeave={() => (productoSeleccionadoRef.current = null)}
              >

                
                <div className="">
                 <h3> <img src={producto.imagen} width="100px" alt="" />  {producto.nombre}</h3>
                </div>
              
               
                <div className="producto-subtotal">
                
                  <button className="btn btn-danger" onClick={() => eliminarProductoDelCarrito(producto._id)}>
                    Eliminar
                  </button>
                  <h4>Agotado desde  {producto.fechaAgregado}</h4>
                </div>
              </li>
            ))}
          
        </div>

     
      </div>
    </div>
         
        </div>
        <div className="modal-footer">
            
        </div>
      </div>
    </div>
  </div>
    






)}
  {modalActivo === "pro-oriente" && (
    <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ background: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Pro Oriente</h5>
              <button className="btn-close" onClick={() => setModalActivo(null)}></button>
       
        </div>
        <div className="modal-body">
         

 <div className="container">
      <div className="row ">
      
       <input
  ref={inputRef}
  type="text"
  placeholder="Escanee el código de barras o escribe el nombre del producto"
  value={filtro}
  onChange={handleFiltroChange}
  onKeyPress={handleKeyPress}
  onFocus={() => setMantenerFocoBusqueda(true)}
  style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
/>
<h1>Productos agotados</h1>
        
        {filtro === '' ? (
    <p></p>
  ) :productosFiltrados.length === 0 ? (
          <p>No se encontraron productos que coincidan con la busqueda</p>
        ) : (
          <div className="row">
           {productosFiltrados.map((producto, index) => {
  const esSeleccionado = indiceSeleccionado === index;

  return (
    <div key={index} className="col-12 col-lg-4">
      <div
        className={`card card-legumbre ${esSeleccionado ? 'seleccionado' : ''}`}
        style={{
          backgroundImage: `url(${producto.imagen})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '200px',
          color: esSeleccionado ? 'white' : 'black',
          position: 'relative',
          marginBottom: '20px',
          borderRadius: '10px',
          overflow: 'hidden',
          filter: esSeleccionado ? 'none' : 'brightness(1)',
          border: esSeleccionado ? '2px solid #007bff' : '1px solid #ccc',
          boxShadow: esSeleccionado ? '0 0 10px #007bff' : 'none',
        }}
      >
        <div
          className="card-body"
          style={{
            backgroundColor: esSeleccionado ? 'rgba(40, 66, 50, 0.69)' : 'rgba(134, 249, 176, 0.54)',
            height: '100%',
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <h4 className="card-title" style={{ fontWeight: 'bold' }}>{producto.nombre}</h4>
           
          

           
          </div>

          <button
            className="btn btn-primary btn-legumbre mt-2"
            onClick={() => agregarAlCarrito(producto)}
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
  );
})}

          </div>
        )}
        
        <div className="col-md-9">
          
            {carrito3.filter(producto => producto.origen === "pro-oriente").slice().reverse().map((producto, index) => (
              <li
                key={index}
                className="producto-item"
                onMouseEnter={() => (productoSeleccionadoRef.current = producto._id)}
                onMouseLeave={() => (productoSeleccionadoRef.current = null)}
              >

                
                <div className="">
                 <h3> <img src={producto.imagen} width="100px" alt="" />  {producto.nombre}</h3>
                </div>
              
               
                <div className="producto-subtotal">
                
                  <button className="btn btn-danger" onClick={() => eliminarProductoDelCarrito(producto._id)}>
                    Eliminar
                  </button>
                  <h4>Agotado desde  {producto.fechaAgregado}</h4>
                </div>
              </li>
            ))}
          
        </div>

     
      </div>
    </div>
         
        </div>
        <div className="modal-footer">
            
        </div>
      </div>
    </div>
  </div>
    )}
    

{modalActivo === "red-de-marcas" && (
    <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ background: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Red de marcas</h5>
              <button className="btn-close" onClick={() => setModalActivo(null)}></button>
       
        </div>
        <div className="modal-body">
         

 <div className="container">
      <div className="row ">
      
       <input
  ref={inputRef}
  type="text"
  placeholder="Escanee el código de barras o escribe el nombre del producto"
  value={filtro}
  onChange={handleFiltroChange}
  onKeyPress={handleKeyPress}
  onFocus={() => setMantenerFocoBusqueda(true)}
  style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
/>
<h1>Productos agotados</h1>
        
        {filtro === '' ? (
    <p></p>
  ) :productosFiltrados.length === 0 ? (
          <p>No se encontraron productos que coincidan con la busqueda</p>
        ) : (
          <div className="row">
           {productosFiltrados.map((producto, index) => {
  const esSeleccionado = indiceSeleccionado === index;

  return (
    <div key={index} className="col-12 col-lg-4">
      <div
        className={`card card-legumbre ${esSeleccionado ? 'seleccionado' : ''}`}
        style={{
          backgroundImage: `url(${producto.imagen})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '200px',
          color: esSeleccionado ? 'white' : 'black',
          position: 'relative',
          marginBottom: '20px',
          borderRadius: '10px',
          overflow: 'hidden',
          filter: esSeleccionado ? 'none' : 'brightness(1)',
          border: esSeleccionado ? '2px solid #007bff' : '1px solid #ccc',
          boxShadow: esSeleccionado ? '0 0 10px #007bff' : 'none',
        }}
      >
        <div
          className="card-body"
          style={{
            backgroundColor: esSeleccionado ? 'rgba(40, 66, 50, 0.69)' : 'rgba(134, 249, 176, 0.54)',
            height: '100%',
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <h4 className="card-title" style={{ fontWeight: 'bold' }}>{producto.nombre}</h4>
           
          

           
          </div>

          <button
            className="btn btn-primary btn-legumbre mt-2"
            onClick={() => agregarAlCarrito(producto)}
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
  );
})}

          </div>
        )}
          <div className="col-md-9">
          
            {carrito3.filter(producto => producto.origen === "red-de-marcas").slice().reverse().map((producto, index) => (
              <li
                key={index}
                className="producto-item"
                onMouseEnter={() => (productoSeleccionadoRef.current = producto._id)}
                onMouseLeave={() => (productoSeleccionadoRef.current = null)}
              >

                
                <div className="">
                 <h3> <img src={producto.imagen} width="100px" alt="" />  {producto.nombre}</h3>
                </div>
              
               
                <div className="producto-subtotal">
                
                  <button className="btn btn-danger" onClick={() => eliminarProductoDelCarrito(producto._id)}>
                    Eliminar
                  </button>
                  <h4>Agotado desde  {producto.fechaAgregado}</h4>
                </div>
              </li>
            ))}
          
        </div>

     
      </div>
    </div>
         
        </div>
        <div className="modal-footer">
            
        </div>
      </div>
    </div>
  </div>
    






)}
  {modalActivo === "quala" && (
    <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ background: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Quala</h5>
              <button className="btn-close" onClick={() => setModalActivo(null)}></button>
       
        </div>
        <div className="modal-body">
         

 <div className="container">
      <div className="row ">
      
       <input
  ref={inputRef}
  type="text"
  placeholder="Escanee el código de barras o escribe el nombre del producto"
  value={filtro}
  onChange={handleFiltroChange}
  onKeyPress={handleKeyPress}
  onFocus={() => setMantenerFocoBusqueda(true)}
  style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
/>
<h1>Productos agotados</h1>
        
        {filtro === '' ? (
    <p></p>
  ) :productosFiltrados.length === 0 ? (
          <p>No se encontraron productos que coincidan con la busqueda</p>
        ) : (
          <div className="row">
           {productosFiltrados.map((producto, index) => {
  const esSeleccionado = indiceSeleccionado === index;

  return (
    <div key={index} className="col-12 col-lg-4">
      <div
        className={`card card-legumbre ${esSeleccionado ? 'seleccionado' : ''}`}
        style={{
          backgroundImage: `url(${producto.imagen})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '200px',
          color: esSeleccionado ? 'white' : 'black',
          position: 'relative',
          marginBottom: '20px',
          borderRadius: '10px',
          overflow: 'hidden',
          filter: esSeleccionado ? 'none' : 'brightness(1)',
          border: esSeleccionado ? '2px solid #007bff' : '1px solid #ccc',
          boxShadow: esSeleccionado ? '0 0 10px #007bff' : 'none',
        }}
      >
        <div
          className="card-body"
          style={{
            backgroundColor: esSeleccionado ? 'rgba(40, 66, 50, 0.69)' : 'rgba(134, 249, 176, 0.54)',
            height: '100%',
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <h4 className="card-title" style={{ fontWeight: 'bold' }}>{producto.nombre}</h4>
           
          

           
          </div>

          <button
            className="btn btn-primary btn-legumbre mt-2"
            onClick={() => agregarAlCarrito(producto)}
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
  );
})}

          </div>
        )}
        
        <div className="col-md-9">
          
            {carrito3.filter(producto => producto.origen === "quala").slice().reverse().map((producto, index) => (
              <li
                key={index}
                className="producto-item"
                onMouseEnter={() => (productoSeleccionadoRef.current = producto._id)}
                onMouseLeave={() => (productoSeleccionadoRef.current = null)}
              >

                
                <div className="">
                 <h3> <img src={producto.imagen} width="100px" alt="" />  {producto.nombre}</h3>
                </div>
              
               
                <div className="producto-subtotal">
                
                  <button className="btn btn-danger" onClick={() => eliminarProductoDelCarrito(producto._id)}>
                    Eliminar
                  </button>
                  <h4>Agotado desde  {producto.fechaAgregado}</h4>
                </div>
              </li>
            ))}
          
        </div>

     
      </div>
    </div>
         
        </div>
        <div className="modal-footer">
            
        </div>
      </div>
    </div>
  </div>
    






)}
  {modalActivo === "ramo" && (
    <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ background: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Ramo</h5>
              <button className="btn-close" onClick={() => setModalActivo(null)}></button>
       
        </div>
        <div className="modal-body">
         

 <div className="container">
      <div className="row ">
      
       <input
  ref={inputRef}
  type="text"
  placeholder="Escanee el código de barras o escribe el nombre del producto"
  value={filtro}
  onChange={handleFiltroChange}
  onKeyPress={handleKeyPress}
  onFocus={() => setMantenerFocoBusqueda(true)}
  style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
/>
<h1>Productos agotados</h1>
        
        {filtro === '' ? (
    <p></p>
  ) :productosFiltrados.length === 0 ? (
          <p>No se encontraron productos que coincidan con la busqueda</p>
        ) : (
          <div className="row">
           {productosFiltrados.map((producto, index) => {
  const esSeleccionado = indiceSeleccionado === index;

  return (
    <div key={index} className="col-12 col-lg-4">
      <div
        className={`card card-legumbre ${esSeleccionado ? 'seleccionado' : ''}`}
        style={{
          backgroundImage: `url(${producto.imagen})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '200px',
          color: esSeleccionado ? 'white' : 'black',
          position: 'relative',
          marginBottom: '20px',
          borderRadius: '10px',
          overflow: 'hidden',
          filter: esSeleccionado ? 'none' : 'brightness(1)',
          border: esSeleccionado ? '2px solid #007bff' : '1px solid #ccc',
          boxShadow: esSeleccionado ? '0 0 10px #007bff' : 'none',
        }}
      >
        <div
          className="card-body"
          style={{
            backgroundColor: esSeleccionado ? 'rgba(40, 66, 50, 0.69)' : 'rgba(134, 249, 176, 0.54)',
            height: '100%',
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <h4 className="card-title" style={{ fontWeight: 'bold' }}>{producto.nombre}</h4>
           
          

           
          </div>

          <button
            className="btn btn-primary btn-legumbre mt-2"
            onClick={() => agregarAlCarrito(producto)}
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
  );
})}

          </div>
        )}
        
        <div className="col-md-9">
          
            {carrito3.filter(producto => producto.origen === "ramo").slice().reverse().map((producto, index) => (
              <li
                key={index}
                className="producto-item"
                onMouseEnter={() => (productoSeleccionadoRef.current = producto._id)}
                onMouseLeave={() => (productoSeleccionadoRef.current = null)}
              >

                
                <div className="">
                 <h3> <img src={producto.imagen} width="100px" alt="" />  {producto.nombre}</h3>
                </div>
              
               
                <div className="producto-subtotal">
                
                  <button className="btn btn-danger" onClick={() => eliminarProductoDelCarrito(producto._id)}>
                    Eliminar
                  </button>
                  <h4>Agotado desde  {producto.fechaAgregado}</h4>
                </div>
              </li>
            ))}
          
        </div>

     
      </div>
    </div>
         
        </div>
        <div className="modal-footer">
            
        </div>
      </div>
    </div>
  </div>
    )}
{modalActivo === "sonsoneña" && (
    <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ background: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Sonsoneña</h5>
              <button className="btn-close" onClick={() => setModalActivo(null)}></button>
       
        </div>
        <div className="modal-body">
         

 <div className="container">
      <div className="row ">
      
       <input
  ref={inputRef}
  type="text"
  placeholder="Escanee el código de barras o escribe el nombre del producto"
  value={filtro}
  onChange={handleFiltroChange}
  onKeyPress={handleKeyPress}
  onFocus={() => setMantenerFocoBusqueda(true)}
  style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
/>
<h1>Productos agotados</h1>
        
        {filtro === '' ? (
    <p></p>
  ) :productosFiltrados.length === 0 ? (
          <p>No se encontraron productos que coincidan con la busqueda</p>
        ) : (
          <div className="row">
           {productosFiltrados.map((producto, index) => {
  const esSeleccionado = indiceSeleccionado === index;

  return (
    <div key={index} className="col-12 col-lg-4">
      <div
        className={`card card-legumbre ${esSeleccionado ? 'seleccionado' : ''}`}
        style={{
          backgroundImage: `url(${producto.imagen})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '200px',
          color: esSeleccionado ? 'white' : 'black',
          position: 'relative',
          marginBottom: '20px',
          borderRadius: '10px',
          overflow: 'hidden',
          filter: esSeleccionado ? 'none' : 'brightness(1)',
          border: esSeleccionado ? '2px solid #007bff' : '1px solid #ccc',
          boxShadow: esSeleccionado ? '0 0 10px #007bff' : 'none',
        }}
      >
        <div
          className="card-body"
          style={{
            backgroundColor: esSeleccionado ? 'rgba(40, 66, 50, 0.69)' : 'rgba(134, 249, 176, 0.54)',
            height: '100%',
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <h4 className="card-title" style={{ fontWeight: 'bold' }}>{producto.nombre}</h4>
           
          

           
          </div>

          <button
            className="btn btn-primary btn-legumbre mt-2"
            onClick={() => agregarAlCarrito(producto)}
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
  );
})}

          </div>
        )}
        
        <div className="col-md-9">
          
            {carrito3.filter(producto => producto.origen === "sonsoneña").slice().reverse().map((producto, index) => (
              <li
                key={index}
                className="producto-item"
                onMouseEnter={() => (productoSeleccionadoRef.current = producto._id)}
                onMouseLeave={() => (productoSeleccionadoRef.current = null)}
              >

                
                <div className="">
                 <h3> <img src={producto.imagen} width="100px" alt="" />  {producto.nombre}</h3>
                </div>
              
               
                <div className="producto-subtotal">
                
                  <button className="btn btn-danger" onClick={() => eliminarProductoDelCarrito(producto._id)}>
                    Eliminar
                  </button>
                  <h4>Agotado desde  {producto.fechaAgregado}</h4>
                </div>
              </li>
            ))}
          
        </div>

     
      </div>
    </div>
         
        </div>
        <div className="modal-footer">
            
        </div>
      </div>
    </div>
  </div>
    )}

{modalActivo === "somos-sabor" && (
    <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ background: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Somos sabor</h5>
              <button className="btn-close" onClick={() => setModalActivo(null)}></button>
       
        </div>
        <div className="modal-body">
         

 <div className="container">
      <div className="row ">
      
       <input
  ref={inputRef}
  type="text"
  placeholder="Escanee el código de barras o escribe el nombre del producto"
  value={filtro}
  onChange={handleFiltroChange}
  onKeyPress={handleKeyPress}
  onFocus={() => setMantenerFocoBusqueda(true)}
  style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
/>
<h1>Productos agotados</h1>
        
        {filtro === '' ? (
    <p></p>
  ) :productosFiltrados.length === 0 ? (
          <p>No se encontraron productos que coincidan con la busqueda</p>
        ) : (
          <div className="row">
           {productosFiltrados.map((producto, index) => {
  const esSeleccionado = indiceSeleccionado === index;

  return (
    <div key={index} className="col-12 col-lg-4">
      <div
        className={`card card-legumbre ${esSeleccionado ? 'seleccionado' : ''}`}
        style={{
          backgroundImage: `url(${producto.imagen})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '200px',
          color: esSeleccionado ? 'white' : 'black',
          position: 'relative',
          marginBottom: '20px',
          borderRadius: '10px',
          overflow: 'hidden',
          filter: esSeleccionado ? 'none' : 'brightness(1)',
          border: esSeleccionado ? '2px solid #007bff' : '1px solid #ccc',
          boxShadow: esSeleccionado ? '0 0 10px #007bff' : 'none',
        }}
      >
        <div
          className="card-body"
          style={{
            backgroundColor: esSeleccionado ? 'rgba(40, 66, 50, 0.69)' : 'rgba(134, 249, 176, 0.54)',
            height: '100%',
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <h4 className="card-title" style={{ fontWeight: 'bold' }}>{producto.nombre}</h4>
           
          

           
          </div>

          <button
            className="btn btn-primary btn-legumbre mt-2"
            onClick={() => agregarAlCarrito(producto)}
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
  );
})}

          </div>
        )}
        
        <div className="col-md-9">
          
            {carrito3.filter(producto => producto.origen === "somos-sabor").slice().reverse().map((producto, index) => (
              <li
                key={index}
                className="producto-item"
                onMouseEnter={() => (productoSeleccionadoRef.current = producto._id)}
                onMouseLeave={() => (productoSeleccionadoRef.current = null)}
              >

                
                <div className="">
                 <h3> <img src={producto.imagen} width="100px" alt="" />  {producto.nombre}</h3>
                </div>
              
               
                <div className="producto-subtotal">
                
                  <button className="btn btn-danger" onClick={() => eliminarProductoDelCarrito(producto._id)}>
                    Eliminar
                  </button>
                  <h4>Agotado desde  {producto.fechaAgregado}</h4>
                </div>
              </li>
            ))}
          
        </div>

     
      </div>
    </div>
         
        </div>
        <div className="modal-footer">
            
        </div>
      </div>
    </div>
  </div>
    






)}
  {modalActivo === "sol-oriente" && (
    <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ background: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Sol oriente</h5>
              <button className="btn-close" onClick={() => setModalActivo(null)}></button>
       
        </div>
        <div className="modal-body">
         

 <div className="container">
      <div className="row ">
      
       <input
  ref={inputRef}
  type="text"
  placeholder="Escanee el código de barras o escribe el nombre del producto"
  value={filtro}
  onChange={handleFiltroChange}
  onKeyPress={handleKeyPress}
  onFocus={() => setMantenerFocoBusqueda(true)}
  style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
/>
<h1>Productos agotados</h1>
        
        {filtro === '' ? (
    <p></p>
  ) :productosFiltrados.length === 0 ? (
          <p>No se encontraron productos que coincidan con la busqueda</p>
        ) : (
          <div className="row">
           {productosFiltrados.map((producto, index) => {
  const esSeleccionado = indiceSeleccionado === index;

  return (
    <div key={index} className="col-12 col-lg-4">
      <div
        className={`card card-legumbre ${esSeleccionado ? 'seleccionado' : ''}`}
        style={{
          backgroundImage: `url(${producto.imagen})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '200px',
          color: esSeleccionado ? 'white' : 'black',
          position: 'relative',
          marginBottom: '20px',
          borderRadius: '10px',
          overflow: 'hidden',
          filter: esSeleccionado ? 'none' : 'brightness(1)',
          border: esSeleccionado ? '2px solid #007bff' : '1px solid #ccc',
          boxShadow: esSeleccionado ? '0 0 10px #007bff' : 'none',
        }}
      >
        <div
          className="card-body"
          style={{
            backgroundColor: esSeleccionado ? 'rgba(40, 66, 50, 0.69)' : 'rgba(134, 249, 176, 0.54)',
            height: '100%',
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <h4 className="card-title" style={{ fontWeight: 'bold' }}>{producto.nombre}</h4>
           
          

           
          </div>

          <button
            className="btn btn-primary btn-legumbre mt-2"
            onClick={() => agregarAlCarrito(producto)}
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
  );
})}

          </div>
        )}
        
        <div className="col-md-9">
          
            {carrito3.filter(producto => producto.origen === "sol-oriente").slice().reverse().map((producto, index) => (
              <li
                key={index}
                className="producto-item"
                onMouseEnter={() => (productoSeleccionadoRef.current = producto._id)}
                onMouseLeave={() => (productoSeleccionadoRef.current = null)}
              >

                
                <div className="">
                 <h3> <img src={producto.imagen} width="100px" alt="" />  {producto.nombre}</h3>
                </div>
              
               
                <div className="producto-subtotal">
                
                  <button className="btn btn-danger" onClick={() => eliminarProductoDelCarrito(producto._id)}>
                    Eliminar
                  </button>
                  <h4>Agotado desde  {producto.fechaAgregado}</h4>
                </div>
              </li>
            ))}
          
        </div>

     
      </div>
    </div>
         
        </div>
        <div className="modal-footer">
            
        </div>
      </div>
    </div>
  </div>
    )}
{modalActivo === "yupi" && (
    <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ background: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Yupi</h5>
              <button className="btn-close" onClick={() => setModalActivo(null)}></button>
       
        </div>
        <div className="modal-body">
         

 <div className="container">
      <div className="row ">
      
       <input
  ref={inputRef}
  type="text"
  placeholder="Escanee el código de barras o escribe el nombre del producto"
  value={filtro}
  onChange={handleFiltroChange}
  onKeyPress={handleKeyPress}
  onFocus={() => setMantenerFocoBusqueda(true)}
  style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
/>
<h1>Productos agotados</h1>
        
        {filtro === '' ? (
    <p></p>
  ) :productosFiltrados.length === 0 ? (
          <p>No se encontraron productos que coincidan con la busqueda</p>
        ) : (
          <div className="row">
           {productosFiltrados.map((producto, index) => {
  const esSeleccionado = indiceSeleccionado === index;

  return (
    <div key={index} className="col-12 col-lg-4">
      <div
        className={`card card-legumbre ${esSeleccionado ? 'seleccionado' : ''}`}
        style={{
          backgroundImage: `url(${producto.imagen})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '200px',
          color: esSeleccionado ? 'white' : 'black',
          position: 'relative',
          marginBottom: '20px',
          borderRadius: '10px',
          overflow: 'hidden',
          filter: esSeleccionado ? 'none' : 'brightness(1)',
          border: esSeleccionado ? '2px solid #007bff' : '1px solid #ccc',
          boxShadow: esSeleccionado ? '0 0 10px #007bff' : 'none',
        }}
      >
        <div
          className="card-body"
          style={{
            backgroundColor: esSeleccionado ? 'rgba(40, 66, 50, 0.69)' : 'rgba(134, 249, 176, 0.54)',
            height: '100%',
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <h4 className="card-title" style={{ fontWeight: 'bold' }}>{producto.nombre}</h4>
           
          

           
          </div>

          <button
            className="btn btn-primary btn-legumbre mt-2"
            onClick={() => agregarAlCarrito(producto)}
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
  );
})}

          </div>
        )}
        
        <div className="col-md-9">
          
            {carrito3.filter(producto => producto.origen === "yupi").slice().reverse().map((producto, index) => (
              <li
                key={index}
                className="producto-item"
                onMouseEnter={() => (productoSeleccionadoRef.current = producto._id)}
                onMouseLeave={() => (productoSeleccionadoRef.current = null)}
              >

                
                <div className="">
                 <h3> <img src={producto.imagen} width="100px" alt="" />  {producto.nombre}</h3>
                </div>
              
               
                <div className="producto-subtotal">
                
                  <button className="btn btn-danger" onClick={() => eliminarProductoDelCarrito(producto._id)}>
                    Eliminar
                  </button>
                  <h4>Agotado desde  {producto.fechaAgregado}</h4>
                </div>
              </li>
            ))}
          
        </div>

     
      </div>
    </div>
         
        </div>
        <div className="modal-footer">
            
        </div>
      </div>
    </div>
  </div>
    






)}

{modalActivo === "zenu" && (
    <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ background: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Zenu</h5>
              <button className="btn-close" onClick={() => setModalActivo(null)}></button>
       
        </div>
        <div className="modal-body">
         

 <div className="container">
      <div className="row ">
      
       <input
  ref={inputRef}
  type="text"
  placeholder="Escanee el código de barras o escribe el nombre del producto"
  value={filtro}
  onChange={handleFiltroChange}
  onKeyPress={handleKeyPress}
  onFocus={() => setMantenerFocoBusqueda(true)}
  style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
/>
<h1>Productos agotados</h1>
        
        {filtro === '' ? (
    <p></p>
  ) :productosFiltrados.length === 0 ? (
          <p>No se encontraron productos que coincidan con la busqueda</p>
        ) : (
          <div className="row">
           {productosFiltrados.map((producto, index) => {
  const esSeleccionado = indiceSeleccionado === index;

  return (
    <div key={index} className="col-12 col-lg-4">
      <div
        className={`card card-legumbre ${esSeleccionado ? 'seleccionado' : ''}`}
        style={{
          backgroundImage: `url(${producto.imagen})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '200px',
          color: esSeleccionado ? 'white' : 'black',
          position: 'relative',
          marginBottom: '20px',
          borderRadius: '10px',
          overflow: 'hidden',
          filter: esSeleccionado ? 'none' : 'brightness(1)',
          border: esSeleccionado ? '2px solid #007bff' : '1px solid #ccc',
          boxShadow: esSeleccionado ? '0 0 10px #007bff' : 'none',
        }}
      >
        <div
          className="card-body"
          style={{
            backgroundColor: esSeleccionado ? 'rgba(40, 66, 50, 0.69)' : 'rgba(134, 249, 176, 0.54)',
            height: '100%',
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <h4 className="card-title" style={{ fontWeight: 'bold' }}>{producto.nombre}</h4>
           
          

           
          </div>

          <button
            className="btn btn-primary btn-legumbre mt-2"
            onClick={() => agregarAlCarrito(producto)}
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
  );
})}

          </div>
        )}
        
        <div className="col-md-9">
          
            {carrito3.filter(producto => producto.origen === "zenu").slice().reverse().map((producto, index) => (
              <li
                key={index}
                className="producto-item"
                onMouseEnter={() => (productoSeleccionadoRef.current = producto._id)}
                onMouseLeave={() => (productoSeleccionadoRef.current = null)}
              >

                
                <div className="">
                 <h3> <img src={producto.imagen} width="100px" alt="" />  {producto.nombre}</h3>
                </div>
              
               
                <div className="producto-subtotal">
                
                  <button className="btn btn-danger" onClick={() => eliminarProductoDelCarrito(producto._id)}>
                    Eliminar
                  </button>
                  <h4>Agotado desde  {producto.fechaAgregado}</h4>
                </div>
              </li>
            ))}
          
        </div>

     
      </div>
    </div>
         
        </div>
        <div className="modal-footer">
            
        </div>
      </div>
    </div>
  </div>
    






)}

{modalActivo === "otros" && (
    <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ background: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Otros</h5>
              <button className="btn-close" onClick={() => setModalActivo(null)}></button>
       
        </div>
        <div className="modal-body">
         

 <div className="container">
      <div className="row ">
      
       <input
  ref={inputRef}
  type="text"
  placeholder="Escanee el código de barras o escribe el nombre del producto"
  value={filtro}
  onChange={handleFiltroChange}
  onKeyPress={handleKeyPress}
  onFocus={() => setMantenerFocoBusqueda(true)}
  style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
/>
<h1>Productos agotados</h1>
        
        {filtro === '' ? (
    <p></p>
  ) :productosFiltrados.length === 0 ? (
          <p>No se encontraron productos que coincidan con la busqueda</p>
        ) : (
          <div className="row">
           {productosFiltrados.map((producto, index) => {
  const esSeleccionado = indiceSeleccionado === index;

  return (
    <div key={index} className="col-12 col-lg-4">
      <div
        className={`card card-legumbre ${esSeleccionado ? 'seleccionado' : ''}`}
        style={{
          backgroundImage: `url(${producto.imagen})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '200px',
          color: esSeleccionado ? 'white' : 'black',
          position: 'relative',
          marginBottom: '20px',
          borderRadius: '10px',
          overflow: 'hidden',
          filter: esSeleccionado ? 'none' : 'brightness(1)',
          border: esSeleccionado ? '2px solid #007bff' : '1px solid #ccc',
          boxShadow: esSeleccionado ? '0 0 10px #007bff' : 'none',
        }}
      >
        <div
          className="card-body"
          style={{
            backgroundColor: esSeleccionado ? 'rgba(40, 66, 50, 0.69)' : 'rgba(134, 249, 176, 0.54)',
            height: '100%',
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <h4 className="card-title" style={{ fontWeight: 'bold' }}>{producto.nombre}</h4>
           
          

           
          </div>

          <button
            className="btn btn-primary btn-legumbre mt-2"
            onClick={() => agregarAlCarrito(producto)}
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
  );
})}

          </div>
        )}
        
        <div className="col-md-9">
          
            {carrito3.filter(producto => producto.origen === "otros").slice().reverse().map((producto, index) => (
              <li
                key={index}
                className="producto-item"
                onMouseEnter={() => (productoSeleccionadoRef.current = producto._id)}
                onMouseLeave={() => (productoSeleccionadoRef.current = null)}
              >

                
                <div className="">
                 <h3> <img src={producto.imagen} width="100px" alt="" />  {producto.nombre}</h3>
                </div>
              
               
                <div className="producto-subtotal">
                
                  <button className="btn btn-danger" onClick={() => eliminarProductoDelCarrito(producto._id)}>
                    Eliminar
                  </button>
                  <h4>Agotado desde  {producto.fechaAgregado}</h4>
                </div>
              </li>
            ))}
          
        </div>

     
      </div>
    </div>
         
        </div>
        <div className="modal-footer">
            
        </div>
      </div>
    </div>
  </div>
    






)}
  {modalActivo === "mayorista" && (
    <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ background: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Mayorista</h5>
              <button className="btn-close" onClick={() => setModalActivo(null)}></button>
       
        </div>
        <div className="modal-body">
         

 <div className="container">
      <div className="row ">
      
       <input
  ref={inputRef}
  type="text"
  placeholder="Escanee el código de barras o escribe el nombre del producto"
  value={filtro}
  onChange={handleFiltroChange}
  onKeyPress={handleKeyPress}
  onFocus={() => setMantenerFocoBusqueda(true)}
  style={{ width: '100%', padding: '10px', marginBottom: '20px' }}
/>
<h1>Productos agotados</h1>
        
        {filtro === '' ? (
    <p></p>
  ) :productosFiltrados.length === 0 ? (
          <p>No se encontraron productos que coincidan con la busqueda</p>
        ) : (
          <div className="row">
           {productosFiltrados.map((producto, index) => {
  const esSeleccionado = indiceSeleccionado === index;

  return (
    <div key={index} className="col-12 col-lg-4">
      <div
        className={`card card-legumbre ${esSeleccionado ? 'seleccionado' : ''}`}
        style={{
          backgroundImage: `url(${producto.imagen})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '200px',
          color: esSeleccionado ? 'white' : 'black',
          position: 'relative',
          marginBottom: '20px',
          borderRadius: '10px',
          overflow: 'hidden',
          filter: esSeleccionado ? 'none' : 'brightness(1)',
          border: esSeleccionado ? '2px solid #007bff' : '1px solid #ccc',
          boxShadow: esSeleccionado ? '0 0 10px #007bff' : 'none',
        }}
      >
        <div
          className="card-body"
          style={{
            backgroundColor: esSeleccionado ? 'rgba(40, 66, 50, 0.69)' : 'rgba(134, 249, 176, 0.54)',
            height: '100%',
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <h4 className="card-title" style={{ fontWeight: 'bold' }}>{producto.nombre}</h4>
           
          

           
          </div>

          <button
            className="btn btn-primary btn-legumbre mt-2"
            onClick={() => agregarAlCarrito(producto)}
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
  );
})}

          </div>
        )}
        
        <div className="col-md-9">
          
            {carrito3.filter(producto => producto.origen === "mayorista").slice().reverse().map((producto, index) => (
              <li
                key={index}
                className="producto-item"
                onMouseEnter={() => (productoSeleccionadoRef.current = producto._id)}
                onMouseLeave={() => (productoSeleccionadoRef.current = null)}
              >

                
                <div className="">
                 <h3> <img src={producto.imagen} width="100px" alt="" />  {producto.nombre}</h3>
                </div>
              
               
                <div className="producto-subtotal">
                
                  <button className="btn btn-danger" onClick={() => eliminarProductoDelCarrito(producto._id)}>
                    Eliminar
                  </button>
                  <h4>Agotado desde  {producto.fechaAgregado}</h4>
                </div>
              </li>
            ))}
          
        </div>

     
      </div>
    </div>
         
        </div>
        <div className="modal-footer">
            
        </div>
      </div>
    </div>
  </div>
    )}


  </div>
  );
  
}

export default ProductosAgotados;